// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, ServerSentEventsResult, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AcceptInvitationTokenData,
  AcceptInvitationTokenErrors,
  AcceptInvitationTokenResponses,
  CheckEmailData,
  CheckEmailErrors,
  CheckEmailResponses,
  CheckMembershipInviteData,
  CheckMembershipInviteErrors,
  CheckMembershipInviteResponses,
  CheckSlugData,
  CheckSlugErrors,
  CheckSlugResponses,
  ConfirmInvitationAddressData,
  ConfirmInvitationAddressErrors,
  ConfirmInvitationAddressResponses,
  ConfirmMagicLinkData,
  ConfirmMagicLinkErrors,
  CreateApiKeyData,
  CreateApiKeyErrors,
  CreateApiKeyResponses,
  CreateAttachmentsData,
  CreateAttachmentsErrors,
  CreateAttachmentsResponses,
  CreateConnectionData,
  CreateConnectionErrors,
  CreateConnectionResponses,
  CreateOrganizationsData,
  CreateOrganizationsErrors,
  CreateOrganizationsResponses,
  CreatePasskeyData,
  CreatePasskeyErrors,
  CreatePasskeyResponses,
  CreatePushSubscriptionData,
  CreatePushSubscriptionErrors,
  CreatePushSubscriptionResponses,
  CreateRequestData,
  CreateRequestErrors,
  CreateRequestResponses,
  CreateServiceAccountData,
  CreateServiceAccountErrors,
  CreateServiceAccountResponses,
  CreateTotpData,
  CreateTotpErrors,
  CreateTotpResponses,
  DeleteAttachmentsData,
  DeleteAttachmentsErrors,
  DeleteAttachmentsResponses,
  DeleteConnectionData,
  DeleteConnectionErrors,
  DeleteConnectionResponses,
  DeleteMeData,
  DeleteMeErrors,
  DeleteMembershipsData,
  DeleteMembershipsErrors,
  DeleteMembershipsResponses,
  DeleteMeResponses,
  DeleteMyMembershipData,
  DeleteMyMembershipErrors,
  DeleteMyMembershipResponses,
  DeleteOrganizationsData,
  DeleteOrganizationsErrors,
  DeleteOrganizationsResponses,
  DeletePasskeyData,
  DeletePasskeyErrors,
  DeletePasskeyResponses,
  DeletePushSubscriptionData,
  DeletePushSubscriptionErrors,
  DeletePushSubscriptionResponses,
  DeleteRequestsData,
  DeleteRequestsErrors,
  DeleteRequestsResponses,
  DeleteTotpData,
  DeleteTotpErrors,
  DeleteTotpResponses,
  DeleteUsersData,
  DeleteUsersErrors,
  DeleteUsersResponses,
  GeneratePasskeyChallengeData,
  GeneratePasskeyChallengeErrors,
  GeneratePasskeyChallengeResponses,
  GenerateTotpKeyData,
  GenerateTotpKeyErrors,
  GenerateTotpKeyResponses,
  GetApiKeysData,
  GetApiKeysErrors,
  GetApiKeysResponses,
  GetApiProtectedResourceMetadataData,
  GetApiProtectedResourceMetadataErrors,
  GetApiProtectedResourceMetadataResponses,
  GetAppStreamData,
  GetAppStreamErrors,
  GetAppStreamResponses,
  GetAttachmentData,
  GetAttachmentErrors,
  GetAttachmentResponses,
  GetAttachmentsData,
  GetAttachmentsErrors,
  GetAttachmentsResponses,
  GetAuthHealthData,
  GetAuthHealthResponses,
  GetConnectedAppsData,
  GetConnectedAppsErrors,
  GetConnectedAppsResponses,
  GetConnectionsData,
  GetConnectionsErrors,
  GetConnectionsResponses,
  GetMcpProtectedResourceMetadataData,
  GetMcpProtectedResourceMetadataErrors,
  GetMcpProtectedResourceMetadataResponses,
  GetMeData,
  GetMeErrors,
  GetMembersData,
  GetMembersErrors,
  GetMembersResponses,
  GetMeResponses,
  GetMyAuthData,
  GetMyAuthErrors,
  GetMyAuthResponses,
  GetMyInvitationsData,
  GetMyInvitationsErrors,
  GetMyInvitationsResponses,
  GetMyMembershipsData,
  GetMyMembershipsErrors,
  GetMyMembershipsResponses,
  GetNotificationPreferencesData,
  GetNotificationPreferencesErrors,
  GetNotificationPreferencesResponses,
  GetNotificationsData,
  GetNotificationsErrors,
  GetNotificationsResponses,
  GetOrganizationData,
  GetOrganizationErrors,
  GetOrganizationResponses,
  GetOrganizationsData,
  GetOrganizationsErrors,
  GetOrganizationsResponses,
  GetPendingMagicLinkData,
  GetPendingMagicLinkErrors,
  GetPendingMagicLinkResponses,
  GetPendingMembershipsData,
  GetPendingMembershipsErrors,
  GetPendingMembershipsResponses,
  GetPendingMfaData,
  GetPendingMfaErrors,
  GetPendingMfaResponses,
  GetPresignedUrlsData,
  GetPresignedUrlsErrors,
  GetPresignedUrlsResponses,
  GetPublicCountsData,
  GetPublicCountsErrors,
  GetPublicCountsResponses,
  GetPushVapidData,
  GetPushVapidErrors,
  GetPushVapidResponses,
  GetRequestsData,
  GetRequestsErrors,
  GetRequestsResponses,
  GetServiceAccountsData,
  GetServiceAccountsErrors,
  GetServiceAccountsResponses,
  GetSsoEntryData,
  GetSsoEntryErrors,
  GetSsoEntryResponses,
  GetStepUpData,
  GetStepUpErrors,
  GetStepUpPasskeyChallengeData,
  GetStepUpPasskeyChallengeErrors,
  GetStepUpPasskeyChallengeResponses,
  GetStepUpResponses,
  GetTenantsData,
  GetTenantsErrors,
  GetTenantsResponses,
  GetTokenDataData,
  GetTokenDataErrors,
  GetTokenDataResponses,
  GetUnseenCountsData,
  GetUnseenCountsErrors,
  GetUnseenCountsResponses,
  GetUploadTokenData,
  GetUploadTokenErrors,
  GetUploadTokenResponses,
  GetUserData,
  GetUserErrors,
  GetUserResponses,
  GetUsersData,
  GetUsersErrors,
  GetUsersResponses,
  GetYjsTokenData,
  GetYjsTokenErrors,
  GetYjsTokenResponses,
  GithubCallbackData,
  GithubCallbackErrors,
  GithubData,
  GithubErrors,
  GoogleCallbackData,
  GoogleCallbackErrors,
  GoogleData,
  GoogleErrors,
  HandleMcpData,
  HandleMcpErrors,
  HandleMcpResponses,
  HandleMembershipInvitationData,
  HandleMembershipInvitationErrors,
  HandleMembershipInvitationResponses,
  InvokeTokenData,
  InvokeTokenErrors,
  LinkAttachmentKeysData,
  LinkAttachmentKeysErrors,
  LinkAttachmentKeysResponses,
  MarkNotificationsReadData,
  MarkNotificationsReadErrors,
  MarkNotificationsReadResponses,
  MarkSeenData,
  MarkSeenErrors,
  MarkSeenResponses,
  MembershipInviteData,
  MembershipInviteErrors,
  MembershipInviteResponses,
  MicrosoftCallbackData,
  MicrosoftCallbackErrors,
  MicrosoftData,
  MicrosoftErrors,
  OpenUnsubscribeLinkData,
  OpenUnsubscribeLinkErrors,
  PostAppCatchupData,
  PostAppCatchupErrors,
  PostAppCatchupResponses,
  PublishOrganizationData,
  PublishOrganizationErrors,
  PublishOrganizationResponses,
  PullYjsDocumentData,
  PullYjsDocumentErrors,
  PullYjsDocumentResponses,
  PushYjsUpdateData,
  PushYjsUpdateErrors,
  PushYjsUpdateResponses,
  ResendInvitationWithTokenData,
  ResendInvitationWithTokenErrors,
  ResendInvitationWithTokenResponses,
  ResendPendingInvitationData,
  ResendPendingInvitationErrors,
  ResendPendingInvitationResponses,
  ResubscribeNotificationsData,
  ResubscribeNotificationsErrors,
  ResubscribeNotificationsResponses,
  RevokeApiKeyData,
  RevokeApiKeyErrors,
  RevokeApiKeyResponses,
  RevokeConnectedAppData,
  RevokeConnectedAppErrors,
  RevokeConnectedAppResponses,
  RevokeMySessionsData,
  RevokeMySessionsErrors,
  RevokeMySessionsResponses,
  SelfCreateTenantData,
  SelfCreateTenantErrors,
  SelfCreateTenantResponses,
  SendMagicLinkData,
  SendMagicLinkErrors,
  SendMagicLinkResponses,
  SendNewsletterData,
  SendNewsletterErrors,
  SendNewsletterResponses,
  SendSsoRecoveryLinkData,
  SendSsoRecoveryLinkErrors,
  SendSsoRecoveryLinkResponses,
  SendStepUpCodeData,
  SendStepUpCodeErrors,
  SendStepUpCodeResponses,
  SignInWithPasskeyData,
  SignInWithPasskeyErrors,
  SignInWithPasskeyResponses,
  SignInWithTotpData,
  SignInWithTotpErrors,
  SignInWithTotpResponses,
  SignOutData,
  SignOutErrors,
  SignOutResponses,
  SsoCallbackData,
  SsoCallbackErrors,
  StartOAuthConnectData,
  StartOAuthConnectErrors,
  StartOAuthConnectResponses,
  StartSsoData,
  StartSsoErrors,
  StartSsoFederationData,
  StartSsoFederationErrors,
  StepUpData,
  StepUpErrors,
  StepUpResponses,
  SystemInviteData,
  SystemInviteErrors,
  SystemInviteResponses,
  ToggleMfaData,
  ToggleMfaErrors,
  ToggleMfaResponses,
  UnsubscribeNotificationsData,
  UnsubscribeNotificationsErrors,
  UnsubscribeNotificationsResponses,
  UpdateAttachmentData,
  UpdateAttachmentErrors,
  UpdateAttachmentResponses,
  UpdateConnectionData,
  UpdateConnectionErrors,
  UpdateConnectionResponses,
  UpdateMeData,
  UpdateMeErrors,
  UpdateMembershipData,
  UpdateMembershipErrors,
  UpdateMembershipResponses,
  UpdateMeResponses,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesErrors,
  UpdateNotificationPreferencesResponses,
  UpdateOrganizationData,
  UpdateOrganizationErrors,
  UpdateOrganizationResponses,
  UpdateServiceAccountData,
  UpdateServiceAccountErrors,
  UpdateServiceAccountResponses,
  UpdateTenantData,
  UpdateTenantErrors,
  UpdateTenantResponses,
  UpdateUserData,
  UpdateUserErrors,
  UpdateUserResponses,
  WithdrawPendingInvitationData,
  WithdrawPendingInvitationErrors,
  WithdrawPendingInvitationResponses,
} from './types.gen';
import {
  zAcceptInvitationTokenResponse,
  zCheckEmailResponse,
  zCheckMembershipInviteResponse,
  zCheckSlugResponse,
  zConfirmInvitationAddressResponse,
  zCreateApiKeyResponse,
  zCreateAttachmentsResponse,
  zCreateConnectionResponse,
  zCreateOrganizationsResponse,
  zCreatePasskeyResponse,
  zCreatePushSubscriptionResponse,
  zCreateRequestResponse,
  zCreateServiceAccountResponse,
  zDeleteAttachmentsResponse,
  zDeleteConnectionResponse,
  zDeleteMembershipsResponse,
  zDeleteMeResponse,
  zDeleteMyMembershipResponse,
  zDeleteOrganizationsResponse,
  zDeletePasskeyResponse,
  zDeletePushSubscriptionResponse,
  zDeleteRequestsResponse,
  zDeleteTotpResponse,
  zDeleteUsersResponse,
  zGeneratePasskeyChallengeResponse,
  zGenerateTotpKeyResponse,
  zGetApiKeysResponse,
  zGetApiProtectedResourceMetadataResponse,
  zGetAttachmentResponse,
  zGetAttachmentsResponse,
  zGetAuthHealthResponse,
  zGetConnectedAppsResponse,
  zGetConnectionsResponse,
  zGetMcpProtectedResourceMetadataResponse,
  zGetMembersResponse,
  zGetMeResponse,
  zGetMyAuthResponse,
  zGetMyInvitationsResponse,
  zGetMyMembershipsResponse,
  zGetNotificationPreferencesResponse,
  zGetNotificationsResponse,
  zGetOrganizationResponse,
  zGetOrganizationsResponse,
  zGetPendingMagicLinkResponse,
  zGetPendingMembershipsResponse,
  zGetPendingMfaResponse,
  zGetPresignedUrlsResponse,
  zGetPublicCountsResponse,
  zGetPushVapidResponse,
  zGetRequestsResponse,
  zGetServiceAccountsResponse,
  zGetSsoEntryResponse,
  zGetStepUpPasskeyChallengeResponse,
  zGetStepUpResponse,
  zGetTenantsResponse,
  zGetTokenDataResponse,
  zGetUnseenCountsResponse,
  zGetUploadTokenResponse,
  zGetUserResponse,
  zGetUsersResponse,
  zGetYjsTokenResponse,
  zHandleMembershipInvitationResponse,
  zLinkAttachmentKeysResponse,
  zMarkNotificationsReadResponse,
  zMarkSeenResponse,
  zMembershipInviteResponse,
  zPostAppCatchupResponse,
  zPublishOrganizationResponse,
  zPullYjsDocumentResponse,
  zPushYjsUpdateResponse,
  zResendInvitationWithTokenResponse,
  zResendPendingInvitationResponse,
  zResubscribeNotificationsResponse,
  zRevokeApiKeyResponse,
  zRevokeConnectedAppResponse,
  zRevokeMySessionsResponse,
  zSelfCreateTenantResponse,
  zSendMagicLinkResponse,
  zSendNewsletterResponse,
  zSendSsoRecoveryLinkResponse,
  zSendStepUpCodeResponse,
  zSignInWithPasskeyResponse,
  zSignInWithTotpResponse,
  zSignOutResponse,
  zStartOAuthConnectResponse,
  zStepUpResponse,
  zSystemInviteResponse,
  zToggleMfaResponse,
  zUnsubscribeNotificationsResponse,
  zUpdateAttachmentResponse,
  zUpdateConnectionResponse,
  zUpdateMembershipResponse,
  zUpdateMeResponse,
  zUpdateNotificationPreferencesResponse,
  zUpdateOrganizationResponse,
  zUpdateServiceAccountResponse,
  zUpdateTenantResponse,
  zUpdateUserResponse,
  zWithdrawPendingInvitationResponse,
} from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<
  TData,
  ThrowOnError,
  TResponse
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Auth health check
 *
 * Returns auth health status including whether the client IP is rate-limited for email enumeration protection.
 *
 * **GET /auth/health** ·· [getAuthHealth](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/health) ·· _auth · cella_
 *
 * @param {getAuthHealthData} options
 * @returns Possible status codes: 200
 */
export const getAuthHealth = <ThrowOnError extends boolean = true>(
  options?: Options<GetAuthHealthData, ThrowOnError>,
): RequestResult<GetAuthHealthResponses, unknown, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetAuthHealthResponses, unknown, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetAuthHealthResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/health',
    ...options,
  });

/**
 * Check email
 *
 * Tells whether this browser has signed in to the account with this email address before, by its device cookie. Any other browser gets `recognized: false`, whether or not the address has an account.
 *
 * **POST /auth/check-email** ·· [checkEmail](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/check-email) ·· _auth · cella_
 *
 * @param {checkEmailData} options
 * @param {string=} options.body.email - `string` (optional)
 * @returns Possible status codes: 200, 400, 413, 429
 */
export const checkEmail = <ThrowOnError extends boolean = true>(
  options: Options<CheckEmailData, ThrowOnError>,
): RequestResult<CheckEmailResponses, CheckEmailErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CheckEmailResponses, CheckEmailErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCheckEmailResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/check-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get pending MFA challenge
 *
 * For the MFA challenge a sign-in left in this browser: the address of the account it completes, so the MFA page can name it in any browser.
 *
 * **GET /auth/mfa/pending** ·· [getPendingMfa](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/mfa/pending) ·· _auth · cella_
 *
 * @param {getPendingMfaData} options
 * @returns Possible status codes: 200, 401
 */
export const getPendingMfa = <ThrowOnError extends boolean = true>(
  options?: Options<GetPendingMfaData, ThrowOnError>,
): RequestResult<GetPendingMfaResponses, GetPendingMfaErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetPendingMfaResponses, GetPendingMfaErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPendingMfaResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/mfa/pending',
    ...options,
  });

/**
 * Invoke token session
 *
 * Opens an emailed link of a link-carried token type: a magic link or a provider address verification signs in, an invitation hands the app a single-use token session in a cookie. Redirects to the app.
 *
 * **GET /auth/invoke-token/{type}/{token}** ·· [invokeToken](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/invoke-token/{type}/{token}) ·· _auth · cella_
 *
 * @param {invokeTokenData} options
 * @param {enum} options.path.type - `enum`
 * @param {string} options.path.token - `string`
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const invokeToken = <ThrowOnError extends boolean = true>(
  options: Options<InvokeTokenData, ThrowOnError>,
): RequestResult<unknown, InvokeTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, InvokeTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/invoke-token/{type}/{token}',
    ...options,
  });

/**
 * Get token data
 *
 * Gets basic data of the token held in the single-use token session: its address and, for a membership invitation, what it grants. It answers only while the session is valid.
 *
 * **GET /auth/token/{type}/{id}** ·· [getTokenData](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/token/{type}/{id}) ·· _auth · cella_
 *
 * @param {getTokenDataData} options
 * @param {enum} options.path.type - `enum`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 429
 */
export const getTokenData = <ThrowOnError extends boolean = true>(
  options: Options<GetTokenDataData, ThrowOnError>,
): RequestResult<GetTokenDataResponses, GetTokenDataErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetTokenDataResponses, GetTokenDataErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetTokenDataResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/token/{type}/{id}',
    ...options,
  });

/**
 * Accept invitation token as current user
 *
 * Accepts the membership invitation held in the single-use token session as the signed-in user, who must hold the invited address. An account on another address first confirms it (`confirmInvitationAddress`); until then the answer is 403 `invitation_address_unproven`. Only an invitation not yet bound to another user can be accepted this way.
 *
 * **POST /auth/invitation-token/accept** ·· [acceptInvitationToken](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/invitation-token/accept) ·· _auth · cella_
 *
 * @param {acceptInvitationTokenData} options
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 429
 */
export const acceptInvitationToken = <ThrowOnError extends boolean = true>(
  options?: Options<AcceptInvitationTokenData, ThrowOnError>,
): RequestResult<AcceptInvitationTokenResponses, AcceptInvitationTokenErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<AcceptInvitationTokenResponses, AcceptInvitationTokenErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zAcceptInvitationTokenResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/invitation-token/accept',
    ...options,
  });

/**
 * Confirm the invited address
 *
 * Mails the address the invitation in the single-use token session went to a new link, bound to the signed-in account. The new link replaces the older ones; opened from that inbox, it adds the address to the account and lets it accept.
 *
 * **POST /auth/invitation-token/confirm-address** ·· [confirmInvitationAddress](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/invitation-token/confirm-address) ·· _auth · cella_
 *
 * @param {confirmInvitationAddressData} options
 * @returns Possible status codes: 204, 400, 401, 404, 409, 429
 */
export const confirmInvitationAddress = <ThrowOnError extends boolean = true>(
  options?: Options<ConfirmInvitationAddressData, ThrowOnError>,
): RequestResult<ConfirmInvitationAddressResponses, ConfirmInvitationAddressErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<ConfirmInvitationAddressResponses, ConfirmInvitationAddressErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zConfirmInvitationAddressResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/invitation-token/confirm-address',
    ...options,
  });

/**
 * Resend invitation
 *
 * Re-sends a pending invitation, named by the id of one of its tokens, to the address it went to. The fresh link replaces the older ones. Answers 204 whether or not an email went out.
 *
 * **POST /auth/resend-invitation** ·· [resendInvitationWithToken](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/resend-invitation) ·· _auth · cella_
 *
 * @param {resendInvitationWithTokenData} options
 * @param {string=} options.body.tokenId - `string` (optional)
 * @returns Possible status codes: 204, 400, 413, 429
 */
export const resendInvitationWithToken = <ThrowOnError extends boolean = true>(
  options: Options<ResendInvitationWithTokenData, ThrowOnError>,
): RequestResult<ResendInvitationWithTokenResponses, ResendInvitationWithTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<ResendInvitationWithTokenResponses, ResendInvitationWithTokenErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zResendInvitationWithTokenResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/resend-invitation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Sign out
 *
 * Signs out the current user: the session is revoked (its row stays for the sessions list) and the cookie is cleared.
 *
 * **POST /auth/sign-out** ·· [signOut](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/sign-out) ·· _auth · cella_
 *
 * @param {signOutData} options
 * @returns Possible status codes: 204, 401
 */
export const signOut = <ThrowOnError extends boolean = true>(
  options?: Options<SignOutData, ThrowOnError>,
): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSignOutResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/sign-out',
    ...options,
  });

/**
 * Send magic link
 *
 * Sends a magic link sign-in email to the specified address. Returns 204 whether or not the address has an account. An account whose organization requires its institution's sign-in gets a mail pointing there; only a browser that signed in to that account gets 403 `sso_required` instead.
 *
 * **POST /auth/magic/send** ·· [sendMagicLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/magic/send) ·· _auth · cella_
 *
 * @param {sendMagicLinkData} options
 * @param {string=} options.body.email - `string` (optional)
 * @param {string=} options.body.redirect - `string` (optional)
 * @returns Possible status codes: 204, 400, 403, 413, 429
 */
export const sendMagicLink = <ThrowOnError extends boolean = true>(
  options: Options<SendMagicLinkData, ThrowOnError>,
): RequestResult<SendMagicLinkResponses, SendMagicLinkErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SendMagicLinkResponses, SendMagicLinkErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSendMagicLinkResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/magic/send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get pending magic link
 *
 * For a magic link opened in a browser that did not request it: the address it signs in, so the holder can recognize the account before confirming.
 *
 * **GET /auth/magic/pending** ·· [getPendingMagicLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/magic/pending) ·· _auth · cella_
 *
 * @param {getPendingMagicLinkData} options
 * @returns Possible status codes: 200, 400, 401, 429
 */
export const getPendingMagicLink = <ThrowOnError extends boolean = true>(
  options?: Options<GetPendingMagicLinkData, ThrowOnError>,
): RequestResult<GetPendingMagicLinkResponses, GetPendingMagicLinkErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetPendingMagicLinkResponses, GetPendingMagicLinkErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPendingMagicLinkResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/magic/pending',
    ...options,
  });

/**
 * Confirm magic link
 *
 * Signs in with the magic link this browser holds, confirmed from the app page. A form post from the app origin; redirects like opening the link.
 *
 * **POST /auth/magic/confirm** ·· [confirmMagicLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/magic/confirm) ·· _auth · cella_
 *
 * @param {confirmMagicLinkData} options
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const confirmMagicLink = <ThrowOnError extends boolean = true>(
  options?: Options<ConfirmMagicLinkData, ThrowOnError>,
): RequestResult<unknown, ConfirmMagicLinkErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<unknown, ConfirmMagicLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/magic/confirm',
    ...options,
  });

/**
 * Generate TOTP key
 *
 * Generates a new TOTP key for current user and returns a provisioning URI and Base32 manual key.
 *
 * **POST /auth/totp/generate-key** ·· [generateTotpKey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/totp/generate-key) ·· _auth · cella_
 *
 * @param {generateTotpKeyData} options
 * @returns Possible status codes: 200, 400, 401, 403, 409, 429
 */
export const generateTotpKey = <ThrowOnError extends boolean = true>(
  options?: Options<GenerateTotpKeyData, ThrowOnError>,
): RequestResult<GenerateTotpKeyResponses, GenerateTotpKeyErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<GenerateTotpKeyResponses, GenerateTotpKeyErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGenerateTotpKeyResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/totp/generate-key',
    ...options,
  });

/**
 * Delete TOTP
 *
 * Delete the current user's authenticator app (TOTP).
 *
 * **DELETE /auth/totp** ·· [deleteTotp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/DELETE/auth/totp) ·· _auth · cella_
 *
 * @param {deleteTotpData} options
 * @returns Possible status codes: 204, 400, 401, 403, 429
 */
export const deleteTotp = <ThrowOnError extends boolean = true>(
  options?: Options<DeleteTotpData, ThrowOnError>,
): RequestResult<DeleteTotpResponses, DeleteTotpErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).delete<DeleteTotpResponses, DeleteTotpErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteTotpResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/totp',
    ...options,
  });

/**
 * Set TOTP
 *
 * Confirms TOTP setup by verifying a code from the authenticator app for the first time. On success, TOTP is registered for current user.
 *
 * **POST /auth/totp** ·· [createTotp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/totp) ·· _auth · cella_
 *
 * @param {createTotpData} options
 * @param {string=} options.body.code - `string` (optional)
 * @returns Possible status codes: 201, 400, 401, 403, 409, 413, 429
 */
export const createTotp = <ThrowOnError extends boolean = true>(
  options: Options<CreateTotpData, ThrowOnError>,
): RequestResult<CreateTotpResponses, CreateTotpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateTotpResponses, CreateTotpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/totp',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify TOTP
 *
 * Validates the TOTP code and completes TOTP based authentication.
 *
 * **POST /auth/totp-verification** ·· [signInWithTotp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/totp-verification) ·· _auth · cella_
 *
 * @param {signInWithTotpData} options
 * @param {string=} options.body.code - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 413, 429
 */
export const signInWithTotp = <ThrowOnError extends boolean = true>(
  options: Options<SignInWithTotpData, ThrowOnError>,
): RequestResult<SignInWithTotpResponses, SignInWithTotpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SignInWithTotpResponses, SignInWithTotpErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSignInWithTotpResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/totp-verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create passkey
 *
 * Register a passkey for passwordless authentication by verifying a signed challenge and linking it to the current user. Multiple passkeys can be created for different devices/browsers.
 *
 * **POST /auth/passkey** ·· [createPasskey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/passkey) ·· _auth · cella_
 *
 * @param {createPasskeyData} options
 * @param {object} options.body.attestation - `object`
 * @param {string=} options.body.nameOnDevice - `string` (optional)
 * @returns Possible status codes: 201, 400, 401, 403, 409, 413, 429
 */
export const createPasskey = <ThrowOnError extends boolean = true>(
  options: Options<CreatePasskeyData, ThrowOnError>,
): RequestResult<CreatePasskeyResponses, CreatePasskeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreatePasskeyResponses, CreatePasskeyErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreatePasskeyResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/passkey',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete passkey
 *
 * Delete a passkey by id from the current user.
 *
 * **DELETE /auth/passkey/{id}** ·· [deletePasskey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/DELETE/auth/passkey/{id}) ·· _auth · cella_
 *
 * @param {deletePasskeyData} options
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 204, 400, 401, 403, 429
 */
export const deletePasskey = <ThrowOnError extends boolean = true>(
  options: Options<DeletePasskeyData, ThrowOnError>,
): RequestResult<DeletePasskeyResponses, DeletePasskeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeletePasskeyResponses, DeletePasskeyErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeletePasskeyResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/passkey/{id}',
    ...options,
  });

/**
 * Generate passkey challenge
 *
 * Initiates the passkey registration or authentication flow by generating a device bound challenge.
 *
 * **POST /auth/passkey/generate-challenge** ·· [generatePasskeyChallenge](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/passkey/generate-challenge) ·· _auth · cella_
 *
 * @param {generatePasskeyChallengeData} options
 * @param {enum=} options.body.type - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 404, 413, 429
 */
export const generatePasskeyChallenge = <ThrowOnError extends boolean = true>(
  options: Options<GeneratePasskeyChallengeData, ThrowOnError>,
): RequestResult<GeneratePasskeyChallengeResponses, GeneratePasskeyChallengeErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<GeneratePasskeyChallengeResponses, GeneratePasskeyChallengeErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGeneratePasskeyChallengeResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/passkey/generate-challenge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify passkey
 *
 * Validates the signed challenge and completes passkey based authentication.
 *
 * **POST /auth/passkey-verification** ·· [signInWithPasskey](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/passkey-verification) ·· _auth · cella_
 *
 * @param {signInWithPasskeyData} options
 * @param {object} options.body.assertion - `object`
 * @param {enum=} options.body.type - `enum` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 413, 429
 */
export const signInWithPasskey = <ThrowOnError extends boolean = true>(
  options: Options<SignInWithPasskeyData, ThrowOnError>,
): RequestResult<SignInWithPasskeyResponses, SignInWithPasskeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SignInWithPasskeyResponses, SignInWithPasskeyErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSignInWithPasskeyResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/passkey-verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start connecting a provider
 *
 * Pins this browser's next provider sign-in with `type=connect` to the current user, for ten minutes and once: the provider's callback connects the provider account to the user that started it. Call it right before sending the browser to the provider.
 *
 * **POST /auth/oauth-connect** ·· [startOAuthConnect](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/oauth-connect) ·· _auth · cella_
 *
 * @param {startOAuthConnectData} options
 * @returns Possible status codes: 204, 400, 401, 403, 429
 */
export const startOAuthConnect = <ThrowOnError extends boolean = true>(
  options?: Options<StartOAuthConnectData, ThrowOnError>,
): RequestResult<StartOAuthConnectResponses, StartOAuthConnectErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<StartOAuthConnectResponses, StartOAuthConnectErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zStartOAuthConnectResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/oauth-connect',
    ...options,
  });

/**
 * Authenticate with GitHub
 *
 * Starts OAuth authentication with GitHub. Can be used for account connection, email verification, invitation process, defaults to authentication.
 *
 * **GET /auth/github** ·· [github](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/github) ·· _auth · cella_
 *
 * @param {githubData} options
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectAfter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401
 */
export const github = <ThrowOnError extends boolean = true>(
  options?: Options<GithubData, ThrowOnError>,
): RequestResult<unknown, GithubErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<unknown, GithubErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/github',
    ...options,
  });

/**
 * Authenticate with Google
 *
 * Starts OAuth authentication with Google. Can be used for account connection, email verification, invitation process, defaults to authentication.
 *
 * **GET /auth/google** ·· [google](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/google) ·· _auth · cella_
 *
 * @param {googleData} options
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectAfter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401
 */
export const google = <ThrowOnError extends boolean = true>(
  options?: Options<GoogleData, ThrowOnError>,
): RequestResult<unknown, GoogleErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<unknown, GoogleErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/google',
    ...options,
  });

/**
 * Authenticate with Microsoft
 *
 * Starts OAuth authentication with Microsoft. Can be used for account connection, email verification, invitation process, defaults to authentication.
 *
 * **GET /auth/microsoft** ·· [microsoft](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/microsoft) ·· _auth · cella_
 *
 * @param {microsoftData} options
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectAfter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401
 */
export const microsoft = <ThrowOnError extends boolean = true>(
  options?: Options<MicrosoftData, ThrowOnError>,
): RequestResult<unknown, MicrosoftErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<unknown, MicrosoftErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/microsoft',
    ...options,
  });

/**
 * Callback for GitHub
 *
 * Handles GitHub OAuth callback, retrieves user identity, and establishes a session or links account.
 *
 * **GET /auth/github/callback** ·· [githubCallback](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/github/callback) ·· _auth · cella_
 *
 * @param {githubCallbackData} options
 * @param {string=} options.query.code - `string` (optional)
 * @param {string} options.query.state - `string`
 * @param {string=} options.query.error - `string` (optional)
 * @param {string=} options.query.error_description - `string` (optional)
 * @param {string=} options.query.error_uri - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const githubCallback = <ThrowOnError extends boolean = true>(
  options: Options<GithubCallbackData, ThrowOnError>,
): RequestResult<unknown, GithubCallbackErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, GithubCallbackErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/github/callback',
    ...options,
  });

/**
 * Callback for Google
 *
 * Handles Google OAuth callback, retrieves user identity, and establishes a session or links account.
 *
 * **GET /auth/google/callback** ·· [googleCallback](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/google/callback) ·· _auth · cella_
 *
 * @param {googleCallbackData} options
 * @param {string=} options.query.code - `string` (optional)
 * @param {string} options.query.state - `string`
 * @param {string=} options.query.error - `string` (optional)
 * @param {string=} options.query.error_description - `string` (optional)
 * @param {string=} options.query.error_uri - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const googleCallback = <ThrowOnError extends boolean = true>(
  options: Options<GoogleCallbackData, ThrowOnError>,
): RequestResult<unknown, GoogleCallbackErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, GoogleCallbackErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/google/callback',
    ...options,
  });

/**
 * Callback for Microsoft
 *
 * Handles Microsoft OAuth callback, retrieves user identity, and establishes a session or links account.
 *
 * **GET /auth/microsoft/callback** ·· [microsoftCallback](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/microsoft/callback) ·· _auth · cella_
 *
 * @param {microsoftCallbackData} options
 * @param {string=} options.query.code - `string` (optional)
 * @param {string} options.query.state - `string`
 * @param {string=} options.query.error - `string` (optional)
 * @param {string=} options.query.error_description - `string` (optional)
 * @param {string=} options.query.error_uri - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const microsoftCallback = <ThrowOnError extends boolean = true>(
  options: Options<MicrosoftCallbackData, ThrowOnError>,
): RequestResult<unknown, MicrosoftCallbackErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, MicrosoftCallbackErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/microsoft/callback',
    ...options,
  });

/**
 * Get an SSO entry
 *
 * What the entry page of an institution's sign-in shows: the organization, the institution and whether sign-in is active. Public by the connection id, the link an institution shares with its members.
 *
 * **GET /auth/sso/connections/{connectionId}** ·· [getSsoEntry](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/sso/connections/{connectionId}) ·· _auth · cella_
 *
 * @param {getSsoEntryData} options
 * @param {string} options.path.connectionId - `string`
 * @returns Possible status codes: 200, 400, 404
 */
export const getSsoEntry = <ThrowOnError extends boolean = true>(
  options: Options<GetSsoEntryData, ThrowOnError>,
): RequestResult<GetSsoEntryResponses, GetSsoEntryErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetSsoEntryResponses, GetSsoEntryErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetSsoEntryResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/sso/connections/{connectionId}',
    ...options,
  });

/**
 * Sign in through an institution
 *
 * Sends the browser to the connection's federation, pinned to the institution's identity providers, so its own picker is skipped. `type=connect` links the institution account to the signed-in user instead; other types are refused.
 *
 * **GET /auth/sso/connections/{connectionId}/start** ·· [startSso](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/sso/connections/{connectionId}/start) ·· _auth · cella_
 *
 * @param {startSsoData} options
 * @param {string} options.path.connectionId - `string`
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectAfter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404
 */
export const startSso = <ThrowOnError extends boolean = true>(
  options: Options<StartSsoData, ThrowOnError>,
): RequestResult<unknown, StartSsoErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, StartSsoErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/sso/connections/{connectionId}/start',
    ...options,
  });

/**
 * Sign in through a federation
 *
 * Sends the browser to the federation without naming an institution: the federation's own picker lists the connected ones, and the callback finds the connection by the institution the sign-in asserts.
 *
 * **GET /auth/sso/federations/{federation}/start** ·· [startSsoFederation](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/sso/federations/{federation}/start) ·· _auth · cella_
 *
 * @param {startSsoFederationData} options
 * @param {string} options.path.federation - `string`
 * @param {enum=} options.query.type - `enum` (optional)
 * @param {string=} options.query.redirectAfter - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 404
 */
export const startSsoFederation = <ThrowOnError extends boolean = true>(
  options: Options<StartSsoFederationData, ThrowOnError>,
): RequestResult<unknown, StartSsoFederationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, StartSsoFederationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/sso/federations/{federation}/start',
    ...options,
  });

/**
 * Callback for SSO
 *
 * The redirect URI registered at every federation. Verifies the tokens, asserts the institution against the connection, signs the user in (creating the account and its membership on a first sign-in) or links the identity, and redirects to the frontend.
 *
 * **GET /auth/sso/callback** ·· [ssoCallback](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/sso/callback) ·· _auth · cella_
 *
 * @param {ssoCallbackData} options
 * @param {string=} options.query.code - `string` (optional)
 * @param {string} options.query.state - `string`
 * @param {string=} options.query.error - `string` (optional)
 * @param {string=} options.query.error_description - `string` (optional)
 * @param {string=} options.query.error_uri - `string` (optional)
 * @returns Possible status codes: 302, 400, 401, 403, 404, 409, 429
 */
export const ssoCallback = <ThrowOnError extends boolean = true>(
  options: Options<SsoCallbackData, ThrowOnError>,
): RequestResult<unknown, SsoCallbackErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, SsoCallbackErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/sso/callback',
    ...options,
  });

/**
 * Send an SSO recovery link
 *
 * For a browser whose institution sign-in was refused because an account already holds the asserted address or the institution does not prove it: mails a magic link to that address, which returns to the account page to connect the institution account. Takes no input; the browser holds the offer for ten minutes and spends it by asking.
 *
 * **POST /auth/sso/recovery-link** ·· [sendSsoRecoveryLink](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/sso/recovery-link) ·· _auth · cella_
 *
 * @param {sendSsoRecoveryLinkData} options
 * @returns Possible status codes: 200, 400, 401, 403, 429
 */
export const sendSsoRecoveryLink = <ThrowOnError extends boolean = true>(
  options?: Options<SendSsoRecoveryLinkData, ThrowOnError>,
): RequestResult<SendSsoRecoveryLinkResponses, SendSsoRecoveryLinkErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<SendSsoRecoveryLinkResponses, SendSsoRecoveryLinkErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSendSsoRecoveryLinkResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/sso/recovery-link',
    ...options,
  });

/**
 * Get step-up state
 *
 * Whether this session stands stepped up for a kind of action, and what the user can offer to step up: a passkey or TOTP they hold, an emailed code, or setting up a second factor.
 *
 * **GET /auth/step-up** ·· [getStepUp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/GET/auth/step-up) ·· _auth · cella_
 *
 * @param {getStepUpData} options
 * @param {enum=} options.query.tier - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401
 */
export const getStepUp = <ThrowOnError extends boolean = true>(
  options?: Options<GetStepUpData, ThrowOnError>,
): RequestResult<GetStepUpResponses, GetStepUpErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetStepUpResponses, GetStepUpErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetStepUpResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/step-up',
    ...options,
  });

/**
 * Step up
 *
 * Proves the user is present on this session with a passkey assertion (to a step-up passkey challenge), a TOTP code of a factor they hold, or the code a step-up mail carried. The proof counts for ten minutes.
 *
 * **POST /auth/step-up** ·· [stepUp](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/step-up) ·· _auth · cella_
 *
 * @param {stepUpData} options
 * @param {object} options.body.passkeyData - `object`
 * @param {string=} options.body.totpCode - `string` (optional)
 * @param {string=} options.body.emailCode - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 404, 413, 429
 */
export const stepUp = <ThrowOnError extends boolean = true>(
  options: Options<StepUpData, ThrowOnError>,
): RequestResult<StepUpResponses, StepUpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<StepUpResponses, StepUpErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zStepUpResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/step-up',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a step-up passkey challenge
 *
 * Issues a passkey challenge for a step-up of this session, bound to the current user, with the user's passkeys to offer. Only a step-up answers it.
 *
 * **POST /auth/step-up/passkey-challenge** ·· [getStepUpPasskeyChallenge](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/step-up/passkey-challenge) ·· _auth · cella_
 *
 * @param {getStepUpPasskeyChallengeData} options
 * @returns Possible status codes: 200, 400, 401, 403, 429
 */
export const getStepUpPasskeyChallenge = <ThrowOnError extends boolean = true>(
  options?: Options<GetStepUpPasskeyChallengeData, ThrowOnError>,
): RequestResult<GetStepUpPasskeyChallengeResponses, GetStepUpPasskeyChallengeErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<GetStepUpPasskeyChallengeResponses, GetStepUpPasskeyChallengeErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetStepUpPasskeyChallengeResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/step-up/passkey-challenge',
    ...options,
  });

/**
 * Email a step-up code
 *
 * For a user without a passkey or TOTP, or one replacing a lost factor while MFA is off: emails a code that steps up this session when entered within ten minutes.
 *
 * **POST /auth/step-up/code** ·· [sendStepUpCode](https://www.cellajs.com/docs/operations?operationTag=auth#tag/auth/POST/auth/step-up/code) ·· _auth · cella_
 *
 * @param {sendStepUpCodeData} options
 * @returns Possible status codes: 204, 400, 401, 403, 409, 429
 */
export const sendStepUpCode = <ThrowOnError extends boolean = true>(
  options?: Options<SendStepUpCodeData, ThrowOnError>,
): RequestResult<SendStepUpCodeResponses, SendStepUpCodeErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).post<SendStepUpCodeResponses, SendStepUpCodeErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSendStepUpCodeResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/auth/step-up/code',
    ...options,
  });

/**
 * Check slug availability
 *
 * Checks whether a given slug is available for the specified entity type. A slug is unique across all tenants. Primarily used to prevent slug collisions before creating or updating an entity.
 *
 * **POST /entities/{tenantId}/check-slug** ·· [checkSlug](https://www.cellajs.com/docs/operations?operationTag=entities#tag/entities/POST/entities/{tenantId}/check-slug) ·· _entities · cella_
 *
 * @param {checkSlugData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string=} options.body.slug - `string` (optional)
 * @param {enum=} options.body.entityType - `enum` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 409, 413, 429
 */
export const checkSlug = <ThrowOnError extends boolean = true>(
  options: Options<CheckSlugData, ThrowOnError>,
): RequestResult<CheckSlugResponses, CheckSlugErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CheckSlugResponses, CheckSlugErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCheckSlugResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/entities/{tenantId}/check-slug',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * App SSE stream
 *
 * SSE stream of what changed for the current user, with ids only: a `change` event for product rows it may read, a `signal` event for anything else, such as its own memberships and inbox.
 *
 * **GET /entities/app/stream** ·· [getAppStream](https://www.cellajs.com/docs/operations?operationTag=entities#tag/entities/GET/entities/app/stream) ·· _entities · cella_
 *
 * @param {getAppStreamData} options
 * @returns Possible status codes: 200, 400, 401, 429
 */
export const getAppStream = <ThrowOnError extends boolean = true>(
  options?: Options<GetAppStreamData, ThrowOnError, unknown>,
): Promise<ServerSentEventsResult<GetAppStreamResponses>> =>
  (options?.client ?? client).sse.get<GetAppStreamResponses, GetAppStreamErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/entities/app/stream',
    ...options,
  });

/**
 * App stream catchup
 *
 * Fetch what a client missed since its last sync: a frontier per declared view (an organization, a product type and its org-sequence cursor in the body), and per organization the versions of its versioned signals.
 *
 * **POST /entities/app/stream** ·· [postAppCatchup](https://www.cellajs.com/docs/operations?operationTag=entities#tag/entities/POST/entities/app/stream) ·· _entities · cella_
 *
 * @param {postAppCatchupData} options
 * @param {any[]=} options.body.views - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 413, 429
 */
export const postAppCatchup = <ThrowOnError extends boolean = true>(
  options: Options<PostAppCatchupData, ThrowOnError>,
): RequestResult<PostAppCatchupResponses, PostAppCatchupErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<PostAppCatchupResponses, PostAppCatchupErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPostAppCatchupResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/entities/app/stream',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete self
 *
 * Deletes the current user. This also removes the user's memberships (cascade) and sets references to the user to null where applicable.
 *
 * **DELETE /me** ·· [deleteMe](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me) ·· _me · cella_
 *
 * @param {deleteMeData} options
 * @returns Possible status codes: 204, 400, 401, 403, 409, 429
 */
export const deleteMe = <ThrowOnError extends boolean = true>(
  options?: Options<DeleteMeData, ThrowOnError>,
): RequestResult<DeleteMeResponses, DeleteMeErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).delete<DeleteMeResponses, DeleteMeErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteMeResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me',
    ...options,
  });

/**
 * Get self
 *
 * Returns the current user.
 *
 * **GET /me** ·· [getMe](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me) ·· _me · cella_
 *
 * @param {getMeData} options
 * @returns Possible status codes: 200, 401
 */
export const getMe = <ThrowOnError extends boolean = true>(
  options?: Options<GetMeData, ThrowOnError>,
): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetMeResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me',
    ...options,
  });

/**
 * Update self
 *
 * Updates the current user.
 *
 * **PUT /me** ·· [updateMe](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/PUT/me) ·· _me · cella_
 *
 * @param {updateMeData} options
 * @param {string | null=} options.body.bannerUrl - `string | null` (optional)
 * @param {enum=} options.body.contrast - `enum` (optional)
 * @param {string | null=} options.body.description - `string | null` (optional)
 * @param {string | null=} options.body.firstName - `string | null` (optional)
 * @param {string | null=} options.body.lastName - `string | null` (optional)
 * @param {enum=} options.body.language - `enum` (optional)
 * @param {boolean=} options.body.newsletter - `boolean` (optional)
 * @param {string | null=} options.body.thumbnailUrl - `string | null` (optional)
 * @param {string=} options.body.slug - `string` (optional)
 * @param {object=} options.body.userFlags - `object` (optional)
 * @returns Possible status codes: 200, 400, 401, 409, 413, 429
 */
export const updateMe = <ThrowOnError extends boolean = true>(
  options: Options<UpdateMeData, ThrowOnError>,
): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateMeResponses, UpdateMeErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateMeResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Toggle MFA
 *
 * Enable or disable multifactor authentication for the current user. Needs a session stepped up with a passkey or TOTP.
 *
 * **PUT /me/mfa** ·· [toggleMfa](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/PUT/me/mfa) ·· _me · cella_
 *
 * @param {toggleMfaData} options
 * @param {boolean=} options.body.mfaRequired - `boolean` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 413, 429
 */
export const toggleMfa = <ThrowOnError extends boolean = true>(
  options: Options<ToggleMfaData, ThrowOnError>,
): RequestResult<ToggleMfaResponses, ToggleMfaErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<ToggleMfaResponses, ToggleMfaErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zToggleMfaResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/mfa',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get auth data
 *
 * Returns authentication related data of current user, including sessions, passkeys, TOTP and the enabled sign-in providers.
 *
 * **GET /me/auth** ·· [getMyAuth](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/auth) ·· _me · cella_
 *
 * @param {getMyAuthData} options
 * @returns Possible status codes: 200, 401
 */
export const getMyAuth = <ThrowOnError extends boolean = true>(
  options?: Options<GetMyAuthData, ThrowOnError>,
): RequestResult<GetMyAuthResponses, GetMyAuthErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMyAuthResponses, GetMyAuthErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetMyAuthResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/auth',
    ...options,
  });

/**
 * Get list of invitations
 *
 * Returns a list of pending memberships with entity data.
 *
 * **GET /me/invitations** ·· [getMyInvitations](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/invitations) ·· _me · cella_
 *
 * @param {getMyInvitationsData} options
 * @returns Possible status codes: 200, 401
 */
export const getMyInvitations = <ThrowOnError extends boolean = true>(
  options?: Options<GetMyInvitationsData, ThrowOnError>,
): RequestResult<GetMyInvitationsResponses, GetMyInvitationsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMyInvitationsResponses, GetMyInvitationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetMyInvitationsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/invitations',
    ...options,
  });

/**
 * Revoke sessions
 *
 * Revokes sessions of the current user by id. The rows stay for the audit trail and the sessions list shows them as revoked for the retention period. Revoking the current session signs out; revoking any other needs a recent proof of presence on this session (step-up).
 *
 * **DELETE /me/sessions** ·· [revokeMySessions](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me/sessions) ·· _me · cella_
 *
 * @param {revokeMySessionsData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 413, 429
 */
export const revokeMySessions = <ThrowOnError extends boolean = true>(
  options: Options<RevokeMySessionsData, ThrowOnError>,
): RequestResult<RevokeMySessionsResponses, RevokeMySessionsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<RevokeMySessionsResponses, RevokeMySessionsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRevokeMySessionsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Leave channel
 *
 * Removes the current user from a channel entity they are a member of.
 *
 * **DELETE /me/leave** ·· [deleteMyMembership](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me/leave) ·· _me · cella_
 *
 * @param {deleteMyMembershipData} options
 * @param {string} options.query.entityId - `string`
 * @param {enum} options.query.entityType - `enum`
 * @returns Possible status codes: 204, 400, 401, 404, 409, 429
 */
export const deleteMyMembership = <ThrowOnError extends boolean = true>(
  options: Options<DeleteMyMembershipData, ThrowOnError>,
): RequestResult<DeleteMyMembershipResponses, DeleteMyMembershipErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteMyMembershipResponses, DeleteMyMembershipErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteMyMembershipResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/leave',
    ...options,
  });

/**
 * Get upload token
 *
 * Generates and returns an upload token for uploading files or images, scoped to the current user and organization. The upload template decides the bucket: avatars, covers and newsletter images are public, attachments private. An attachment token needs an organization the user may create attachments in. Only a system admin gets a newsletter image token.
 *
 * **GET /me/upload-token** ·· [getUploadToken](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/upload-token) ·· _me · cella_
 *
 * @param {getUploadTokenData} options
 * @param {string=} options.query.organizationId - `string` (optional)
 * @param {enum} options.query.templateId - `enum`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 429
 */
export const getUploadToken = <ThrowOnError extends boolean = true>(
  options: Options<GetUploadTokenData, ThrowOnError>,
): RequestResult<GetUploadTokenResponses, GetUploadTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetUploadTokenResponses, GetUploadTokenErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUploadTokenResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/upload-token',
    ...options,
  });

/**
 * Get my memberships
 *
 * Returns all memberships for the current user across all channel entities.
 *
 * **GET /me/memberships** ·· [getMyMemberships](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/memberships) ·· _me · cella_
 *
 * @param {getMyMembershipsData} options
 * @returns Possible status codes: 200, 401
 */
export const getMyMemberships = <ThrowOnError extends boolean = true>(
  options?: Options<GetMyMembershipsData, ThrowOnError>,
): RequestResult<GetMyMembershipsResponses, GetMyMembershipsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetMyMembershipsResponses, GetMyMembershipsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetMyMembershipsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/memberships',
    ...options,
  });

/**
 * Get connected apps
 *
 * Lists the OAuth clients the user consented to (MCP clients, registered apps) with their scopes.
 *
 * **GET /me/connected-apps** ·· [getConnectedApps](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/GET/me/connected-apps) ·· _me · cella_
 *
 * @param {getConnectedAppsData} options
 * @returns Possible status codes: 200, 401
 */
export const getConnectedApps = <ThrowOnError extends boolean = true>(
  options?: Options<GetConnectedAppsData, ThrowOnError>,
): RequestResult<GetConnectedAppsResponses, GetConnectedAppsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetConnectedAppsResponses, GetConnectedAppsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetConnectedAppsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/connected-apps',
    ...options,
  });

/**
 * Revoke connected app
 *
 * Revokes a consent: the grant and every token issued under it are deleted.
 *
 * **DELETE /me/connected-apps/{id}** ·· [revokeConnectedApp](https://www.cellajs.com/docs/operations?operationTag=me#tag/me/DELETE/me/connected-apps/{id}) ·· _me · cella_
 *
 * @param {revokeConnectedAppData} options
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 404, 429
 */
export const revokeConnectedApp = <ThrowOnError extends boolean = true>(
  options: Options<RevokeConnectedAppData, ThrowOnError>,
): RequestResult<RevokeConnectedAppResponses, RevokeConnectedAppErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<RevokeConnectedAppResponses, RevokeConnectedAppErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRevokeConnectedAppResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/me/connected-apps/{id}',
    ...options,
  });

/**
 * Get public counts
 *
 * Returns the number of users and of each channel entity type, such as organizations. This endpoint is public and uses a 1 minute in memory cache for performance.
 *
 * **GET /metrics/public** ·· [getPublicCounts](https://www.cellajs.com/docs/operations?operationTag=metrics#tag/metrics/GET/metrics/public) ·· _metrics · cella_
 *
 * @param {getPublicCountsData} options
 * @returns Possible status codes: 200, 400
 */
export const getPublicCounts = <ThrowOnError extends boolean = true>(
  options?: Options<GetPublicCountsData, ThrowOnError>,
): RequestResult<GetPublicCountsResponses, GetPublicCountsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetPublicCountsResponses, GetPublicCountsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPublicCountsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/metrics/public',
    ...options,
  });

/**
 * List notifications
 *
 * Returns the current user notification inbox, newest first, with the unread count. Ambient posts are not included: those are covered by unseen counts. Rows older than the retention window are removed with their partition.
 *
 * **GET /notifications** ·· [getNotifications](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/GET/notifications) ·· _notifications · cella_
 *
 * @param {getNotificationsData} options
 * @param {enum | boolean=} options.query.unread - `enum | boolean` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {string=} options.query.before - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 429
 */
export const getNotifications = <ThrowOnError extends boolean = true>(
  options?: Options<GetNotificationsData, ThrowOnError>,
): RequestResult<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetNotificationsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/notifications',
    ...options,
  });

/**
 * Mark notifications as read
 *
 * Marks specific notifications read by id, everything sharing one context, or all unread notifications when the body is empty. Idempotent.
 *
 * **POST /notifications/read** ·· [markNotificationsRead](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/POST/notifications/read) ·· _notifications · cella_
 *
 * @param {markNotificationsReadData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @param {string=} options.body.contextId - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 413
 */
export const markNotificationsRead = <ThrowOnError extends boolean = true>(
  options: Options<MarkNotificationsReadData, ThrowOnError>,
): RequestResult<MarkNotificationsReadResponses, MarkNotificationsReadErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<MarkNotificationsReadResponses, MarkNotificationsReadErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zMarkNotificationsReadResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/notifications/read',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get notification preferences
 *
 * Email and digest preferences for the current user. In-app delivery is not opt-out.
 *
 * **GET /notifications/preferences** ·· [getNotificationPreferences](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/GET/notifications/preferences) ·· _notifications · cella_
 *
 * @param {getNotificationPreferencesData} options
 * @returns Possible status codes: 200, 401
 */
export const getNotificationPreferences = <ThrowOnError extends boolean = true>(
  options?: Options<GetNotificationPreferencesData, ThrowOnError>,
): RequestResult<GetNotificationPreferencesResponses, GetNotificationPreferencesErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetNotificationPreferencesResponses, GetNotificationPreferencesErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetNotificationPreferencesResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/notifications/preferences',
    ...options,
  });

/**
 * Update notification preferences
 *
 * Partial update; unspecified keys keep their stored value.
 *
 * **PATCH /notifications/preferences** ·· [updateNotificationPreferences](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/PATCH/notifications/preferences) ·· _notifications · cella_
 *
 * @param {updateNotificationPreferencesData} options
 * @param {boolean=} options.body.mentionEmail - `boolean` (optional)
 * @param {boolean=} options.body.commentEmail - `boolean` (optional)
 * @param {enum=} options.body.digest - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 413
 */
export const updateNotificationPreferences = <ThrowOnError extends boolean = true>(
  options: Options<UpdateNotificationPreferencesData, ThrowOnError>,
): RequestResult<UpdateNotificationPreferencesResponses, UpdateNotificationPreferencesErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).patch<UpdateNotificationPreferencesResponses, UpdateNotificationPreferencesErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateNotificationPreferencesResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/notifications/preferences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Open an unsubscribe link
 *
 * Redirects an unsubscribe link from an email to the page that asks to confirm it, and changes nothing: mail scanners and link previews open links on their own. No auth.
 *
 * **GET /notifications/unsubscribe** ·· [openUnsubscribeLink](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/GET/notifications/unsubscribe) ·· _notifications · cella_
 *
 * @param {openUnsubscribeLinkData} options
 * @param {string} options.query.user - `string`
 * @param {enum} options.query.category - `enum`
 * @param {string} options.query.token - `string`
 * @returns Possible status codes: 302, 400, 429
 */
export const openUnsubscribeLink = <ThrowOnError extends boolean = true>(
  options: Options<OpenUnsubscribeLinkData, ThrowOnError>,
): RequestResult<unknown, OpenUnsubscribeLinkErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<unknown, OpenUnsubscribeLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/notifications/unsubscribe',
    ...options,
  });

/**
 * Unsubscribe from a notification category
 *
 * Turns off one email category. The token identifies the user and the category, so unsubscribing from the digest leaves other email untouched. The confirmation page and a mail client's one-click unsubscribe (RFC 8058) post here. No auth.
 *
 * **POST /notifications/unsubscribe** ·· [unsubscribeNotifications](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/POST/notifications/unsubscribe) ·· _notifications · cella_
 *
 * @param {unsubscribeNotificationsData} options
 * @param {string} options.query.user - `string`
 * @param {enum} options.query.category - `enum`
 * @param {string} options.query.token - `string`
 * @returns Possible status codes: 204, 400, 401, 404, 429
 */
export const unsubscribeNotifications = <ThrowOnError extends boolean = true>(
  options: Options<UnsubscribeNotificationsData, ThrowOnError>,
): RequestResult<UnsubscribeNotificationsResponses, UnsubscribeNotificationsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<UnsubscribeNotificationsResponses, UnsubscribeNotificationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUnsubscribeNotificationsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/notifications/unsubscribe',
    ...options,
  });

/**
 * Turn a notification category back on
 *
 * Undoes an unsubscribe with the same link token, from the page that confirmed it. No auth.
 *
 * **POST /notifications/resubscribe** ·· [resubscribeNotifications](https://www.cellajs.com/docs/operations?operationTag=notifications#tag/notifications/POST/notifications/resubscribe) ·· _notifications · cella_
 *
 * @param {resubscribeNotificationsData} options
 * @param {string} options.query.user - `string`
 * @param {enum} options.query.category - `enum`
 * @param {string} options.query.token - `string`
 * @returns Possible status codes: 204, 400, 401, 404, 429
 */
export const resubscribeNotifications = <ThrowOnError extends boolean = true>(
  options: Options<ResubscribeNotificationsData, ThrowOnError>,
): RequestResult<ResubscribeNotificationsResponses, ResubscribeNotificationsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<ResubscribeNotificationsResponses, ResubscribeNotificationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zResubscribeNotificationsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/notifications/resubscribe',
    ...options,
  });

/**
 * Get the Web Push application server key
 *
 * Returns the VAPID public key `PushManager.subscribe()` needs, or null while push sending is off (push turned off, VAPID keys missing, or keys or subject refused); the client then offers no push toggle.
 *
 * **GET /push/vapid** ·· [getPushVapid](https://www.cellajs.com/docs/operations?operationTag=push#tag/push/GET/push/vapid) ·· _push · cella_
 *
 * @param {getPushVapidData} options
 * @returns Possible status codes: 200, 401
 */
export const getPushVapid = <ThrowOnError extends boolean = true>(
  options?: Options<GetPushVapidData, ThrowOnError>,
): RequestResult<GetPushVapidResponses, GetPushVapidErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetPushVapidResponses, GetPushVapidErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPushVapidResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/push/vapid',
    ...options,
  });

/**
 * Remove a Web Push subscription
 *
 * Deletes the given endpoint for the current user; an endpoint owned by someone else is a no-op.
 *
 * **DELETE /push/subscriptions** ·· [deletePushSubscription](https://www.cellajs.com/docs/operations?operationTag=push#tag/push/DELETE/push/subscriptions) ·· _push · cella_
 *
 * @param {deletePushSubscriptionData} options
 * @param {string} options.query.endpoint - `string`
 * @returns Possible status codes: 200, 400, 401
 */
export const deletePushSubscription = <ThrowOnError extends boolean = true>(
  options: Options<DeletePushSubscriptionData, ThrowOnError>,
): RequestResult<DeletePushSubscriptionResponses, DeletePushSubscriptionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeletePushSubscriptionResponses, DeletePushSubscriptionErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeletePushSubscriptionResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/push/subscriptions',
    ...options,
  });

/**
 * Register a Web Push subscription
 *
 * Stores the browser push subscription for the current user. Upserts by endpoint, so re-subscribing after key rotation reclaims the row. The endpoint must be an https URL of a known browser push service. Past the per-user cap, the least recently seen subscriptions are removed.
 *
 * **POST /push/subscriptions** ·· [createPushSubscription](https://www.cellajs.com/docs/operations?operationTag=push#tag/push/POST/push/subscriptions) ·· _push · cella_
 *
 * @param {createPushSubscriptionData} options
 * @param {string=} options.body.endpoint - `string` (optional)
 * @param {number | null=} options.body.expirationTime - `number | null` (optional)
 * @param {object} options.body.keys - `object`
 * @returns Possible status codes: 200, 400, 401, 413, 429
 */
export const createPushSubscription = <ThrowOnError extends boolean = true>(
  options: Options<CreatePushSubscriptionData, ThrowOnError>,
): RequestResult<CreatePushSubscriptionResponses, CreatePushSubscriptionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreatePushSubscriptionResponses, CreatePushSubscriptionErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreatePushSubscriptionResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/push/subscriptions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete requests
 *
 * Deletes one or more requests from the system by their IDs.
 *
 * **DELETE /requests** ·· [deleteRequests](https://www.cellajs.com/docs/operations?operationTag=requests#tag/requests/DELETE/requests) ·· _requests · cella_
 *
 * @param {deleteRequestsData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 413, 429
 */
export const deleteRequests = <ThrowOnError extends boolean = true>(
  options: Options<DeleteRequestsData, ThrowOnError>,
): RequestResult<DeleteRequestsResponses, DeleteRequestsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteRequestsResponses, DeleteRequestsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteRequestsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of requests
 *
 * Returns a list of submitted requests across all types: contact form, newsletter, and waitlist.
 *
 * **GET /requests** ·· [getRequests](https://www.cellajs.com/docs/operations?operationTag=requests#tag/requests/GET/requests) ·· _requests · cella_
 *
 * @param {getRequestsData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @returns Possible status codes: 200, 400, 401, 403
 */
export const getRequests = <ThrowOnError extends boolean = true>(
  options?: Options<GetRequestsData, ThrowOnError>,
): RequestResult<GetRequestsResponses, GetRequestsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetRequestsResponses, GetRequestsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetRequestsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/requests',
    ...options,
  });

/**
 * Create request
 *
 * Submits a request: a contact form message, a newsletter signup or a waitlist entry. Every submission gets the same answer: a waitlist entry from an address that has an account gets an email pointing to sign-in, and a repeat of a waitlist or newsletter signup is dropped.
 *
 * **POST /requests** ·· [createRequest](https://www.cellajs.com/docs/operations?operationTag=requests#tag/requests/POST/requests) ·· _requests · cella_
 *
 * @param {createRequestData} options
 * @param {string=} options.body.email - `string` (optional)
 * @param {enum=} options.body.type - `enum` (optional)
 * @param {string | null=} options.body.message - `string | null` (optional)
 * @returns Possible status codes: 204, 400, 413, 429
 */
export const createRequest = <ThrowOnError extends boolean = true>(
  options: Options<CreateRequestData, ThrowOnError>,
): RequestResult<CreateRequestResponses, CreateRequestErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateRequestResponses, CreateRequestErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateRequestResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get unseen counts
 *
 * Returns the number of unseen product entities per parent channel entity and entity type for the current user. Counts only entities created or published within the seen window: an older one is never unseen.
 *
 * **GET /unseen/counts** ·· [getUnseenCounts](https://www.cellajs.com/docs/operations?operationTag=seen#tag/seen/GET/unseen/counts) ·· _seen · cella_
 *
 * @param {getUnseenCountsData} options
 * @returns Possible status codes: 200, 400, 401, 429
 */
export const getUnseenCounts = <ThrowOnError extends boolean = true>(
  options?: Options<GetUnseenCountsData, ThrowOnError>,
): RequestResult<GetUnseenCountsResponses, GetUnseenCountsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetUnseenCountsResponses, GetUnseenCountsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUnseenCountsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/unseen/counts',
    ...options,
  });

/**
 * Invite to system
 *
 * Invites one or more users to the system via email. Can be used to onboard system level users or admins.
 *
 * **POST /system/invite** ·· [systemInvite](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/POST/system/invite) ·· _system · cella_
 *
 * @param {systemInviteData} options
 * @param {any[]=} options.body.emails - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 413, 429
 */
export const systemInvite = <ThrowOnError extends boolean = true>(
  options: Options<SystemInviteData, ThrowOnError>,
): RequestResult<SystemInviteResponses, SystemInviteErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SystemInviteResponses, SystemInviteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSystemInviteResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/system/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete users
 *
 * Deletes one or more users from the system based on a list of IDs. This also removes the user's memberships (cascade) and sets references to the user to null where applicable.
 *
 * **DELETE /system** ·· [deleteUsers](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/DELETE/system) ·· _system · cella_
 *
 * @param {deleteUsersData} options
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const deleteUsers = <ThrowOnError extends boolean = true>(
  options: Options<DeleteUsersData, ThrowOnError>,
): RequestResult<DeleteUsersResponses, DeleteUsersErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteUsersResponses, DeleteUsersErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteUsersResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/system',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update user
 *
 * Updates a user identified by ID.
 *
 * **PUT /system/{id}** ·· [updateUser](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/PUT/system/{id}) ·· _system · cella_
 *
 * @param {updateUserData} options
 * @param {string} options.path.id - `string`
 * @param {string | null=} options.body.bannerUrl - `string | null` (optional)
 * @param {string | null=} options.body.description - `string | null` (optional)
 * @param {string | null=} options.body.firstName - `string | null` (optional)
 * @param {string | null=} options.body.lastName - `string | null` (optional)
 * @param {enum=} options.body.language - `enum` (optional)
 * @param {boolean=} options.body.newsletter - `boolean` (optional)
 * @param {string | null=} options.body.thumbnailUrl - `string | null` (optional)
 * @param {string=} options.body.slug - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const updateUser = <ThrowOnError extends boolean = true>(
  options: Options<UpdateUserData, ThrowOnError>,
): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateUserResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/system/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Newsletter to members
 *
 * Sends a newsletter to members of one or more specified organizations.
 *
 * **POST /system/newsletter** ·· [sendNewsletter](https://www.cellajs.com/docs/operations?operationTag=system#tag/system/POST/system/newsletter) ·· _system · cella_
 *
 * @param {sendNewsletterData} options
 * @param {enum | boolean=} options.query.toSelf - `enum | boolean` (optional)
 * @param {any[]=} options.body.organizationIds - `any[]` (optional)
 * @param {any[]=} options.body.roles - `any[]` (optional)
 * @param {string=} options.body.subject - `string` (optional)
 * @param {string=} options.body.content - `string` (optional)
 * @returns Possible status codes: 204, 400, 401, 403, 413, 429
 */
export const sendNewsletter = <ThrowOnError extends boolean = true>(
  options: Options<SendNewsletterData, ThrowOnError>,
): RequestResult<SendNewsletterResponses, SendNewsletterErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SendNewsletterResponses, SendNewsletterErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSendNewsletterResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/system/newsletter',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of tenants
 *
 * Returns a paginated list of tenants. System admin access required.
 *
 * **GET /tenants** ·· [getTenants](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/GET/tenants) ·· _tenants · cella_
 *
 * @param {getTenantsData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {enum=} options.query.status - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403
 */
export const getTenants = <ThrowOnError extends boolean = true>(
  options?: Options<GetTenantsData, ThrowOnError>,
): RequestResult<GetTenantsResponses, GetTenantsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetTenantsResponses, GetTenantsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetTenantsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/tenants',
    ...options,
  });

/**
 * Create a tenant for yourself
 *
 * Creates a new tenant (workspace) for the authenticated user. A user may create several, up to the number the app allows; an org-less tenant from a prior failed attempt is reused, and takes the new name.
 *
 * **POST /tenants/self** ·· [selfCreateTenant](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/POST/tenants/self) ·· _tenants · cella_
 *
 * @param {selfCreateTenantData} options
 * @param {string=} options.body.name - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 413, 429
 */
export const selfCreateTenant = <ThrowOnError extends boolean = true>(
  options: Options<SelfCreateTenantData, ThrowOnError>,
): RequestResult<SelfCreateTenantResponses, SelfCreateTenantErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<SelfCreateTenantResponses, SelfCreateTenantErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zSelfCreateTenantResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/tenants/self',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a tenant
 *
 * Updates a tenant by ID. System admin access required.
 *
 * **PUT /tenants/{tenantId}** ·· [updateTenant](https://www.cellajs.com/docs/operations?operationTag=tenants#tag/tenants/PUT/tenants/{tenantId}) ·· _tenants · cella_
 *
 * @param {updateTenantData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {enum=} options.body.status - `enum` (optional)
 * @param {string | null=} options.body.subscriptionId - `string | null` (optional)
 * @param {enum=} options.body.subscriptionStatus - `enum` (optional)
 * @param {string | null=} options.body.subscriptionPlan - `string | null` (optional)
 * @param {any[]=} options.body.authStrategies - `any[]` (optional)
 * @param {object=} options.body.restrictions - `object` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const updateTenant = <ThrowOnError extends boolean = true>(
  options: Options<UpdateTenantData, ThrowOnError>,
): RequestResult<UpdateTenantResponses, UpdateTenantErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateTenantResponses, UpdateTenantErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateTenantResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/tenants/{tenantId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get connections
 *
 * The tenant's connections: the institutions whose members sign in to its organization through an SSO federation. System admin access required.
 *
 * **GET /tenants/{tenantId}/connections** ·· [getConnections](https://www.cellajs.com/docs/operations?operationTag=connections#tag/connections/GET/tenants/{tenantId}/connections) ·· _connections · cella_
 *
 * @param {getConnectionsData} options
 * @param {string} options.path.tenantId - `string`
 * @returns Possible status codes: 200, 400, 401, 403
 */
export const getConnections = <ThrowOnError extends boolean = true>(
  options: Options<GetConnectionsData, ThrowOnError>,
): RequestResult<GetConnectionsResponses, GetConnectionsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetConnectionsResponses, GetConnectionsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetConnectionsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/tenants/{tenantId}/connections',
    ...options,
  });

/**
 * Create connection
 *
 * Connects an institution to the tenant: the federation it signs in through, its domains and its IdP entity ids. Starts `pending` until the institution activated the service at the federation; one SSO connection per tenant, and a domain belongs to one connection.
 *
 * **POST /tenants/{tenantId}/connections** ·· [createConnection](https://www.cellajs.com/docs/operations?operationTag=connections#tag/connections/POST/tenants/{tenantId}/connections) ·· _connections · cella_
 *
 * @param {createConnectionData} options
 * @param {string} options.path.tenantId - `string`
 * @param {enum=} options.body.issuer - `enum` (optional)
 * @param {string=} options.body.displayName - `string` (optional)
 * @param {any[]=} options.body.claimValues - `any[]` (optional)
 * @param {any[]=} options.body.idpEntityIds - `any[]` (optional)
 * @param {enum=} options.body.status - `enum` (optional)
 * @param {boolean=} options.body.jitProvisioning - `boolean` (optional)
 * @param {string=} options.body.logoUrl - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 409, 413, 429
 */
export const createConnection = <ThrowOnError extends boolean = true>(
  options: Options<CreateConnectionData, ThrowOnError>,
): RequestResult<CreateConnectionResponses, CreateConnectionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateConnectionResponses, CreateConnectionErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateConnectionResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/tenants/{tenantId}/connections',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete connection
 *
 * Removes a connection. Identities and sessions that came through it keep their rows; members stay members.
 *
 * **DELETE /tenants/{tenantId}/connections/{id}** ·· [deleteConnection](https://www.cellajs.com/docs/operations?operationTag=connections#tag/connections/DELETE/tenants/{tenantId}/connections/{id}) ·· _connections · cella_
 *
 * @param {deleteConnectionData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 429
 */
export const deleteConnection = <ThrowOnError extends boolean = true>(
  options: Options<DeleteConnectionData, ThrowOnError>,
): RequestResult<DeleteConnectionResponses, DeleteConnectionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteConnectionResponses, DeleteConnectionErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteConnectionResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/tenants/{tenantId}/connections/{id}',
    ...options,
  });

/**
 * Update connection
 *
 * Changes the name, domains, IdP entity ids, status or provisioning of a connection; the federation stays what it was.
 *
 * **PUT /tenants/{tenantId}/connections/{id}** ·· [updateConnection](https://www.cellajs.com/docs/operations?operationTag=connections#tag/connections/PUT/tenants/{tenantId}/connections/{id}) ·· _connections · cella_
 *
 * @param {updateConnectionData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.id - `string`
 * @param {string=} options.body.displayName - `string` (optional)
 * @param {any[]=} options.body.claimValues - `any[]` (optional)
 * @param {any[]=} options.body.idpEntityIds - `any[]` (optional)
 * @param {enum=} options.body.status - `enum` (optional)
 * @param {boolean=} options.body.jitProvisioning - `boolean` (optional)
 * @param {string=} options.body.logoUrl - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const updateConnection = <ThrowOnError extends boolean = true>(
  options: Options<UpdateConnectionData, ThrowOnError>,
): RequestResult<UpdateConnectionResponses, UpdateConnectionErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateConnectionResponses, UpdateConnectionErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateConnectionResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/tenants/{tenantId}/connections/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of users
 *
 * Returns a list of users. Only system admins receive the system `role`, and only they may filter or sort by it.
 *
 * **GET /users/users** ·· [getUsers](https://www.cellajs.com/docs/operations?operationTag=users#tag/users/GET/users/users) ·· _users · cella_
 *
 * @param {getUsersData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {enum=} options.query.role - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403
 */
export const getUsers = <ThrowOnError extends boolean = true>(
  options?: Options<GetUsersData, ThrowOnError>,
): RequestResult<GetUsersResponses, GetUsersErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUsersResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/users/users',
    ...options,
  });

/**
 * Get user
 *
 * Retrieves a user by ID. The requesting user must share at least one organization membership. Pass ?slug=true to resolve by slug instead. Pass ?include=mfa for `mfaRequired`, which only the user themselves, system admins and admins of an organization the user is a member of receive.
 *
 * **GET /users/users/{relatableUserId}** ·· [getUser](https://www.cellajs.com/docs/operations?operationTag=users#tag/users/GET/users/users/{relatableUserId}) ·· _users · cella_
 *
 * @param {getUserData} options
 * @param {string} options.path.relatableUserId - `string`
 * @param {enum | boolean=} options.query.slug - `enum | boolean` (optional)
 * @param {string=} options.query.include - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404
 */
export const getUser = <ThrowOnError extends boolean = true>(
  options: Options<GetUserData, ThrowOnError>,
): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetUserResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/users/users/{relatableUserId}',
    ...options,
  });

/**
 * Protected resource metadata (API)
 *
 * RFC 9728 metadata of this tenant as an API resource: its resource identifier, the authorization server that issues tokens for it, and the scopes it understands.
 *
 * **GET /{tenantId}/.well-known/oauth-protected-resource** ·· [getApiProtectedResourceMetadata](https://www.cellajs.com/docs/operations?operationTag=oauth-server#tag/oauth-server/GET/{tenantId}/.well-known/oauth-protected-resource) ·· _oauth-server · cella_
 *
 * @param {getApiProtectedResourceMetadataData} options
 * @param {string} options.path.tenantId - `string`
 * @returns Possible status codes: 200, 400, 404
 */
export const getApiProtectedResourceMetadata = <ThrowOnError extends boolean = true>(
  options: Options<GetApiProtectedResourceMetadataData, ThrowOnError>,
): RequestResult<GetApiProtectedResourceMetadataResponses, GetApiProtectedResourceMetadataErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetApiProtectedResourceMetadataResponses, GetApiProtectedResourceMetadataErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetApiProtectedResourceMetadataResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/.well-known/oauth-protected-resource',
    ...options,
  });

/**
 * Delete organizations
 *
 * Deletes organizations by ID within a tenant. Deleting archives the tenant: members lose access at once, and the organization with everything in it is removed after the archived period; until then a system admin can restore it.
 *
 * **DELETE /{tenantId}/organizations** ·· [deleteOrganizations](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/DELETE/{tenantId}/organizations) ·· _organizations · cella · channel_
 *
 * @param {deleteOrganizationsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 413, 429
 */
export const deleteOrganizations = <ThrowOnError extends boolean = true>(
  options: Options<DeleteOrganizationsData, ThrowOnError>,
): RequestResult<DeleteOrganizationsResponses, DeleteOrganizationsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteOrganizationsResponses, DeleteOrganizationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteOrganizationsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create organizations
 *
 * Creates one or more new organizations within a tenant.
 *
 * **POST /{tenantId}/organizations** ·· [createOrganizations](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/POST/{tenantId}/organizations) ·· _organizations · cella · channel_
 *
 * @param {createOrganizationsData} options
 * @param {string} options.path.tenantId - `string`
 * @returns Possible status codes: 201, 400, 401, 403, 409, 413, 429
 */
export const createOrganizations = <ThrowOnError extends boolean = true>(
  options: Options<CreateOrganizationsData, ThrowOnError>,
): RequestResult<CreateOrganizationsResponses, CreateOrganizationsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateOrganizationsResponses, CreateOrganizationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateOrganizationsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get list of organizations
 *
 * Returns a list of organizations.
 *
 * **GET /organizations** ·· [getOrganizations](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/GET/organizations) ·· _organizations · cella · channel_
 *
 * @param {getOrganizationsData} options
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {string=} options.query.relatableUserId - `string` (optional)
 * @param {enum=} options.query.role - `enum` (optional)
 * @param {enum | boolean=} options.query.excludeArchived - `enum | boolean` (optional)
 * @param {string=} options.query.include - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403
 */
export const getOrganizations = <ThrowOnError extends boolean = true>(
  options?: Options<GetOrganizationsData, ThrowOnError>,
): RequestResult<GetOrganizationsResponses, GetOrganizationsErrors, ThrowOnError, 'data'> =>
  (options?.client ?? client).get<GetOrganizationsResponses, GetOrganizationsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetOrganizationsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/organizations',
    ...options,
  });

/**
 * Get organization
 *
 * Retrieves an organization by ID within a tenant. Pass ?slug=true to resolve by slug instead.
 *
 * **GET /{tenantId}/organizations/{id}** ·· [getOrganization](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/GET/{tenantId}/organizations/{id}) ·· _organizations · cella · channel_
 *
 * @param {getOrganizationData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.id - `string`
 * @param {enum | boolean=} options.query.slug - `enum | boolean` (optional)
 * @param {string=} options.query.include - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404
 */
export const getOrganization = <ThrowOnError extends boolean = true>(
  options: Options<GetOrganizationData, ThrowOnError>,
): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetOrganizationResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/organizations/{id}',
    ...options,
  });

/**
 * Update organization
 *
 * Updates an organization within a tenant.
 *
 * **PUT /{tenantId}/organizations/{id}** ·· [updateOrganization](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/PUT/{tenantId}/organizations/{id}) ·· _organizations · cella · channel_
 *
 * @param {updateOrganizationData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.id - `string`
 * @param {string=} options.body.slug - `string` (optional)
 * @param {string=} options.body.name - `string` (optional)
 * @param {string | null=} options.body.shortName - `string | null` (optional)
 * @param {string | null=} options.body.country - `string | null` (optional)
 * @param {string | null=} options.body.timezone - `string | null` (optional)
 * @param {enum=} options.body.defaultLanguage - `enum` (optional)
 * @param {any[]=} options.body.languages - `any[]` (optional)
 * @param {string | null=} options.body.notificationEmail - `string | null` (optional)
 * @param {string | null=} options.body.color - `string | null` (optional)
 * @param {string | null=} options.body.thumbnailUrl - `string | null` (optional)
 * @param {string | null=} options.body.logoUrl - `string | null` (optional)
 * @param {string | null=} options.body.bannerUrl - `string | null` (optional)
 * @param {string | null=} options.body.websiteUrl - `string | null` (optional)
 * @param {string | null=} options.body.welcomeText - `string | null` (optional)
 * @param {boolean=} options.body.chatSupport - `boolean` (optional)
 * @param {object=} options.body.organizationFlags - `object` (optional)
 * @param {object=} options.body.setupConfig - `object` (optional)
 * @param {object=} options.body.toolsConfig - `object` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const updateOrganization = <ThrowOnError extends boolean = true>(
  options: Options<UpdateOrganizationData, ThrowOnError>,
): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateOrganizationResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/organizations/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Publish organization
 *
 * Publishes a draft organization, then sends the invitations it held for every role except its prepare roles. Safe to repeat: on a published organization it sends invitations an earlier call left waiting.
 *
 * **PUT /{tenantId}/organizations/{id}/publish** ·· [publishOrganization](https://www.cellajs.com/docs/operations?operationTag=organizations#tag/organizations/PUT/{tenantId}/organizations/{id}/publish) ·· _organizations · cella · channel_
 *
 * @param {publishOrganizationData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 429
 */
export const publishOrganization = <ThrowOnError extends boolean = true>(
  options: Options<PublishOrganizationData, ThrowOnError>,
): RequestResult<PublishOrganizationResponses, PublishOrganizationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<PublishOrganizationResponses, PublishOrganizationErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPublishOrganizationResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/organizations/{id}/publish',
    ...options,
  });

/**
 * Delete attachments
 *
 * Deletes one or more attachments by ID. Their stored files are kept for the deleted-items period, then deleted when the retention procedure removes the rows.
 *
 * **DELETE /{tenantId}/{organizationId}/attachments** ·· [deleteAttachments](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/DELETE/{tenantId}/{organizationId}/attachments) ·· _attachments · cella · product_
 *
 * @param {deleteAttachmentsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @param {object} options.body.stx - `object`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const deleteAttachments = <ThrowOnError extends boolean = true>(
  options: Options<DeleteAttachmentsData, ThrowOnError>,
): RequestResult<DeleteAttachmentsResponses, DeleteAttachmentsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteAttachmentsResponses, DeleteAttachmentsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteAttachmentsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get attachments
 *
 * Returns a paginated list of attachments for the organization.
 *
 * **GET /{tenantId}/{organizationId}/attachments** ·· [getAttachments](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/GET/{tenantId}/{organizationId}/attachments) ·· _attachments · cella · product_
 *
 * @param {getAttachmentsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {integer=} options.query.afterSeq - `integer` (optional)
 * @param {integer=} options.query.untilSeq - `integer` (optional)
 * @param {string=} options.query.channelId - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 429
 */
export const getAttachments = <ThrowOnError extends boolean = true>(
  options: Options<GetAttachmentsData, ThrowOnError>,
): RequestResult<GetAttachmentsResponses, GetAttachmentsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetAttachmentsResponses, GetAttachmentsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetAttachmentsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/attachments',
    ...options,
  });

/**
 * Create attachments
 *
 * Registers one or more new attachments after client side upload. Includes metadata like name, content type, size and storage keys. Every storage key must lie under the caller's own upload prefix and name a stored object; the size comes from storage.
 *
 * **POST /{tenantId}/{organizationId}/attachments** ·· [createAttachments](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/POST/{tenantId}/{organizationId}/attachments) ·· _attachments · cella · product_
 *
 * @param {createAttachmentsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @returns Possible status codes: 200, 201, 400, 401, 403, 404, 413, 429
 */
export const createAttachments = <ThrowOnError extends boolean = true>(
  options: Options<CreateAttachmentsData, ThrowOnError>,
): RequestResult<CreateAttachmentsResponses, CreateAttachmentsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateAttachmentsResponses, CreateAttachmentsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateAttachmentsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/attachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get presigned URLs
 *
 * Signs download URLs for up to 50 private attachment files in one call, referenced by id + variant. Missing and denied ids come back in a uniform rejectedIds list (no 403/404 split), and the call succeeds even when every item is rejected. Public files should use the public CDN URL directly. Requires organization context.
 *
 * **POST /{tenantId}/{organizationId}/attachments/presigned-urls** ·· [getPresignedUrls](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/POST/{tenantId}/{organizationId}/attachments/presigned-urls) ·· _attachments · cella · product_
 *
 * @param {getPresignedUrlsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {any[]=} options.body.items - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const getPresignedUrls = <ThrowOnError extends boolean = true>(
  options: Options<GetPresignedUrlsData, ThrowOnError>,
): RequestResult<GetPresignedUrlsResponses, GetPresignedUrlsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<GetPresignedUrlsResponses, GetPresignedUrlsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPresignedUrlsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/attachments/presigned-urls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get attachment
 *
 * Returns a single attachment by ID.
 *
 * **GET /{tenantId}/{organizationId}/attachments/{id}** ·· [getAttachment](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/GET/{tenantId}/{organizationId}/attachments/{id}) ·· _attachments · cella · product_
 *
 * @param {getAttachmentData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404
 */
export const getAttachment = <ThrowOnError extends boolean = true>(
  options: Options<GetAttachmentData, ThrowOnError>,
): RequestResult<GetAttachmentResponses, GetAttachmentErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetAttachmentResponses, GetAttachmentErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetAttachmentResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/attachments/{id}',
    ...options,
  });

/**
 * Update attachment
 *
 * Renames an attachment or replaces its description.
 *
 * **PUT /{tenantId}/{organizationId}/attachments/{id}** ·· [updateAttachment](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/PUT/{tenantId}/{organizationId}/attachments/{id}) ·· _attachments · cella · product_
 *
 * @param {updateAttachmentData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @param {object=} options.body.ops - `object` (optional)
 * @param {any=} options.body.stx - `any` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const updateAttachment = <ThrowOnError extends boolean = true>(
  options: Options<UpdateAttachmentData, ThrowOnError>,
): RequestResult<UpdateAttachmentResponses, UpdateAttachmentErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateAttachmentResponses, UpdateAttachmentErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateAttachmentResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/attachments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Link attachment keys
 *
 * Stores the storage keys of a file its uploader uploaded after creating the attachment, for a file added offline. Only the uploader may link them, under their own upload prefix, and only while the attachment has no stored file. Repeating the same keys returns the attachment unchanged.
 *
 * **PUT /{tenantId}/{organizationId}/attachments/{id}/keys** ·· [linkAttachmentKeys](https://www.cellajs.com/docs/operations?operationTag=attachments#tag/attachments/PUT/{tenantId}/{organizationId}/attachments/{id}/keys) ·· _attachments · cella · product_
 *
 * @param {linkAttachmentKeysData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @param {object} options.body.keys - `object`
 * @param {string | null=} options.body.convertedContentType - `string | null` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const linkAttachmentKeys = <ThrowOnError extends boolean = true>(
  options: Options<LinkAttachmentKeysData, ThrowOnError>,
): RequestResult<LinkAttachmentKeysResponses, LinkAttachmentKeysErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<LinkAttachmentKeysResponses, LinkAttachmentKeysErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zLinkAttachmentKeysResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/attachments/{id}/keys',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Protected resource metadata
 *
 * RFC 9728 metadata of this organization MCP server: its resource identifier, the authorization server that issues tokens for it, and the scopes it understands.
 *
 * **GET /{tenantId}/{organizationId}/mcp/.well-known/oauth-protected-resource** ·· [getMcpProtectedResourceMetadata](https://www.cellajs.com/docs/operations?operationTag=mcp#tag/mcp/GET/{tenantId}/{organizationId}/mcp/.well-known/oauth-protected-resource) ·· _mcp · cella_
 *
 * @param {getMcpProtectedResourceMetadataData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @returns Possible status codes: 200, 400, 404
 */
export const getMcpProtectedResourceMetadata = <ThrowOnError extends boolean = true>(
  options: Options<GetMcpProtectedResourceMetadataData, ThrowOnError>,
): RequestResult<GetMcpProtectedResourceMetadataResponses, GetMcpProtectedResourceMetadataErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetMcpProtectedResourceMetadataResponses, GetMcpProtectedResourceMetadataErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetMcpProtectedResourceMetadataResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/mcp/.well-known/oauth-protected-resource',
    ...options,
  });

/**
 * MCP endpoint
 *
 * Model Context Protocol (JSON-RPC 2.0 over Streamable HTTP) endpoint. Requires an access token from the authorization server; exposes the MCP tools that modules registered (initialize, tools/list, tools/call). A missing or invalid token answers 401 with a WWW-Authenticate challenge naming where to find the authorization server metadata. A call outside the token scopes answers 403 with a WWW-Authenticate challenge naming the scope to step up to; in a batch it gets its own insufficient_scope error, the other calls keep their results, and the 200 carries the challenge.
 *
 * **POST /{tenantId}/{organizationId}/mcp** ·· [handleMcp](https://www.cellajs.com/docs/operations?operationTag=mcp#tag/mcp/POST/{tenantId}/{organizationId}/mcp) ·· _mcp · cella_
 *
 * @param {handleMcpData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const handleMcp = <ThrowOnError extends boolean = true>(
  options: Options<HandleMcpData, ThrowOnError>,
): RequestResult<HandleMcpResponses, HandleMcpErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<HandleMcpResponses, HandleMcpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/mcp',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete memberships
 *
 * Deletes the memberships of one or more members of a channel entity, named by their user IDs; the users themselves stay. An ID without a membership in the channel comes back in `rejectedIds`.
 *
 * **DELETE /{tenantId}/{organizationId}/memberships** ·· [deleteMemberships](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/DELETE/{tenantId}/{organizationId}/memberships) ·· _memberships · cella_
 *
 * @param {deleteMembershipsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.query.entityId - `string`
 * @param {enum} options.query.entityType - `enum`
 * @param {any[]=} options.body.ids - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const deleteMemberships = <ThrowOnError extends boolean = true>(
  options: Options<DeleteMembershipsData, ThrowOnError>,
): RequestResult<DeleteMembershipsResponses, DeleteMembershipsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<DeleteMembershipsResponses, DeleteMembershipsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zDeleteMembershipsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create memberships
 *
 * Invites addresses to a channel entity such as an organization and says per address what happened: a new invitation, the earlier one sent again (a higher role replaces a lower one), an organization member added at once, or a member left out. A declined invitation stays declined for `retention.declinedInvitationHoldDays` and only then opens again. A tenant mails an address at most once a day: an address it mailed within the day gets no mail and no new link, and the link it holds keeps working. Past the tenant's daily invitation mails (`invitationMailsPerDay`) the request answers 429 and changes nothing. A created membership carries muted, archived and display order only when it is the caller's own.
 *
 * **POST /{tenantId}/{organizationId}/memberships** ·· [membershipInvite](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/POST/{tenantId}/{organizationId}/memberships) ·· _memberships · cella_
 *
 * @param {membershipInviteData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.query.entityId - `string`
 * @param {enum} options.query.entityType - `enum`
 * @param {any[]=} options.body.emails - `any[]` (optional)
 * @param {enum=} options.body.role - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const membershipInvite = <ThrowOnError extends boolean = true>(
  options: Options<MembershipInviteData, ThrowOnError>,
): RequestResult<MembershipInviteResponses, MembershipInviteErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<MembershipInviteResponses, MembershipInviteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zMembershipInviteResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check addresses before inviting
 *
 * Says per address what an invite would do, from what the caller already sees: members by their listed address and the channel's own invitations. Writes and sends nothing. Requires update permission on the channel.
 *
 * **POST /{tenantId}/{organizationId}/memberships/check** ·· [checkMembershipInvite](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/POST/{tenantId}/{organizationId}/memberships/check) ·· _memberships · cella_
 *
 * @param {checkMembershipInviteData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.query.entityId - `string`
 * @param {enum} options.query.entityType - `enum`
 * @param {any[]=} options.body.emails - `any[]` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const checkMembershipInvite = <ThrowOnError extends boolean = true>(
  options: Options<CheckMembershipInviteData, ThrowOnError>,
): RequestResult<CheckMembershipInviteResponses, CheckMembershipInviteErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CheckMembershipInviteResponses, CheckMembershipInviteErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCheckMembershipInviteResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships/check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update membership
 *
 * Updates a membership: its role, or the muted, archived or display order status. Send at least one field. Muted, archived and display order are set by the member only, and the response carries them only on the caller's own membership. An archive that sends no display order moves the row to the top of the archived rows, a restore to the bottom of the active ones. A channel type whose menu section sets `archivable: false` cannot be archived. A role change, and any change to another member's membership, requires update permission on the channel.
 *
 * **PUT /{tenantId}/{organizationId}/memberships/{id}** ·· [updateMembership](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/PUT/{tenantId}/{organizationId}/memberships/{id}) ·· _memberships · cella_
 *
 * @param {updateMembershipData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @param {enum=} options.body.role - `enum` (optional)
 * @param {boolean=} options.body.archived - `boolean` (optional)
 * @param {boolean=} options.body.muted - `boolean` (optional)
 * @param {number=} options.body.displayOrder - `number` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const updateMembership = <ThrowOnError extends boolean = true>(
  options: Options<UpdateMembershipData, ThrowOnError>,
): RequestResult<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateMembershipResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Respond to membership invitation
 *
 * Accepting makes the caller a member of the invited channel, or leaves a membership they hold as it is; rejecting declines the invitation, and its emailed link stops working. Either answer returns the invitation's organization.
 *
 * **POST /{tenantId}/{organizationId}/memberships/{id}/{acceptOrReject}** ·· [handleMembershipInvitation](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/POST/{tenantId}/{organizationId}/memberships/{id}/{acceptOrReject}) ·· _memberships · cella_
 *
 * @param {handleMembershipInvitationData} options
 * @param {string} options.path.id - `string`
 * @param {enum} options.path.acceptOrReject - `enum`
 * @returns Possible status codes: 200, 400, 401, 404, 409, 429
 */
export const handleMembershipInvitation = <ThrowOnError extends boolean = true>(
  options: Options<HandleMembershipInvitationData, ThrowOnError>,
): RequestResult<HandleMembershipInvitationResponses, HandleMembershipInvitationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<HandleMembershipInvitationResponses, HandleMembershipInvitationErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zHandleMembershipInvitationResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships/{id}/{acceptOrReject}',
    ...options,
  });

/**
 * Get list of members
 *
 * Retrieves members (users) of a channel entity by ID, including their associated membership data. Pass ?include=counts for per-member counts, and ?include=mfa for `mfaRequired`, which only admins of the organization receive.
 *
 * **GET /{tenantId}/{organizationId}/memberships/members** ·· [getMembers](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/GET/{tenantId}/{organizationId}/memberships/members) ·· _memberships · cella_
 *
 * @param {getMembersData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {string} options.query.entityId - `string`
 * @param {enum} options.query.entityType - `enum`
 * @param {enum=} options.query.role - `enum` (optional)
 * @param {string=} options.query.include - `string` (optional)
 * @param {string=} options.query.userIds - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404
 */
export const getMembers = <ThrowOnError extends boolean = true>(
  options: Options<GetMembersData, ThrowOnError>,
): RequestResult<GetMembersResponses, GetMembersErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetMembersResponses, GetMembersErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetMembersResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships/members',
    ...options,
  });

/**
 * Get list of pending memberships
 *
 * Returns the pending invitations of a channel entity, identified by ID, to every user who may read it: the address each went to, its role and its inviter. A row looks the same whether an account holds the address or not.
 *
 * **GET /{tenantId}/{organizationId}/memberships/pending** ·· [getPendingMemberships](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/GET/{tenantId}/{organizationId}/memberships/pending) ·· _memberships · cella_
 *
 * @param {getPendingMembershipsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {enum=} options.query.sort - `enum` (optional)
 * @param {enum=} options.query.order - `enum` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @param {string} options.query.entityId - `string`
 * @param {enum} options.query.entityType - `enum`
 * @returns Possible status codes: 200, 400, 401, 403, 404
 */
export const getPendingMemberships = <ThrowOnError extends boolean = true>(
  options: Options<GetPendingMembershipsData, ThrowOnError>,
): RequestResult<GetPendingMembershipsResponses, GetPendingMembershipsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetPendingMembershipsResponses, GetPendingMembershipsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetPendingMembershipsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships/pending',
    ...options,
  });

/**
 * Resend pending invitation
 *
 * Re-sends the invitation email for a pending membership, named by its own id; an invitation holding a token gets a fresh one, and one held in a draft channel waits for its publish. An address the tenant mailed within the day gets nothing, and the link it holds keeps working. Answers 204 alike for every pending invitation, and 429 past the tenant's daily invitation mails. Requires update permission on the invited channel; the public auth resend endpoint stays for invitees holding an expired token.
 *
 * **POST /{tenantId}/{organizationId}/memberships/pending/{id}/resend** ·· [resendPendingInvitation](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/POST/{tenantId}/{organizationId}/memberships/pending/{id}/resend) ·· _memberships · cella_
 *
 * @param {resendPendingInvitationData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 204, 400, 401, 403, 404, 429
 */
export const resendPendingInvitation = <ThrowOnError extends boolean = true>(
  options: Options<ResendPendingInvitationData, ThrowOnError>,
): RequestResult<ResendPendingInvitationResponses, ResendPendingInvitationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<ResendPendingInvitationResponses, ResendPendingInvitationErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zResendPendingInvitationResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships/pending/{id}/resend',
    ...options,
  });

/**
 * Withdraw pending invitation
 *
 * Withdraws a pending invitation, named by its own id, with its links, so its seat frees. A declined invitation is the invitee's answer and is not withdrawn. Requires update permission on the invited channel.
 *
 * **DELETE /{tenantId}/{organizationId}/memberships/pending/{id}** ·· [withdrawPendingInvitation](https://www.cellajs.com/docs/operations?operationTag=memberships#tag/memberships/DELETE/{tenantId}/{organizationId}/memberships/pending/{id}) ·· _memberships · cella_
 *
 * @param {withdrawPendingInvitationData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 204, 400, 401, 403, 404, 429
 */
export const withdrawPendingInvitation = <ThrowOnError extends boolean = true>(
  options: Options<WithdrawPendingInvitationData, ThrowOnError>,
): RequestResult<WithdrawPendingInvitationResponses, WithdrawPendingInvitationErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<WithdrawPendingInvitationResponses, WithdrawPendingInvitationErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zWithdrawPendingInvitationResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/memberships/pending/{id}',
    ...options,
  });

/**
 * Mark entities as seen
 *
 * Records that the current user has viewed one or more product entities. Deduplicates against existing records. Updates entity view counts for newly seen entities.
 *
 * **POST /{tenantId}/{organizationId}/seen** ·· [markSeen](https://www.cellajs.com/docs/operations?operationTag=seen#tag/seen/POST/{tenantId}/{organizationId}/seen) ·· _seen · cella_
 *
 * @param {markSeenData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {any[]=} options.body.entityIds - `any[]` (optional)
 * @param {enum=} options.body.entityType - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const markSeen = <ThrowOnError extends boolean = true>(
  options: Options<MarkSeenData, ThrowOnError>,
): RequestResult<MarkSeenResponses, MarkSeenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<MarkSeenResponses, MarkSeenErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zMarkSeenResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/seen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get service accounts
 *
 * Lists the service accounts of this organization.
 *
 * **GET /{tenantId}/{organizationId}/service-accounts** ·· [getServiceAccounts](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/GET/{tenantId}/{organizationId}/service-accounts) ·· _service-accounts · cella_
 *
 * @param {getServiceAccountsData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string=} options.query.q - `string` (optional)
 * @param {integer=} options.query.offset - `integer` (optional)
 * @param {integer=} options.query.limit - `integer` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404
 */
export const getServiceAccounts = <ThrowOnError extends boolean = true>(
  options: Options<GetServiceAccountsData, ThrowOnError>,
): RequestResult<GetServiceAccountsResponses, GetServiceAccountsErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetServiceAccountsResponses, GetServiceAccountsErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetServiceAccountsResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/service-accounts',
    ...options,
  });

/**
 * Create service account
 *
 * Creates a machine actor bound to this organization at the given role (capped at your own), optionally issuing its first API key in the same call.
 *
 * **POST /{tenantId}/{organizationId}/service-accounts** ·· [createServiceAccount](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/POST/{tenantId}/{organizationId}/service-accounts) ·· _service-accounts · cella_
 *
 * @param {createServiceAccountData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {enum=} options.body.role - `enum` (optional)
 * @param {object} options.body.key - `object`
 * @returns Possible status codes: 201, 400, 401, 403, 404, 413, 429
 */
export const createServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<CreateServiceAccountData, ThrowOnError>,
): RequestResult<CreateServiceAccountResponses, CreateServiceAccountErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateServiceAccountResponses, CreateServiceAccountErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateServiceAccountResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/service-accounts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update service account
 *
 * Renames, disables or re-enables a service account. Accounts are never deleted.
 *
 * **PUT /{tenantId}/{organizationId}/service-accounts/{id}** ·· [updateServiceAccount](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/PUT/{tenantId}/{organizationId}/service-accounts/{id}) ·· _service-accounts · cella_
 *
 * @param {updateServiceAccountData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {enum=} options.body.status - `enum` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const updateServiceAccount = <ThrowOnError extends boolean = true>(
  options: Options<UpdateServiceAccountData, ThrowOnError>,
): RequestResult<UpdateServiceAccountResponses, UpdateServiceAccountErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).put<UpdateServiceAccountResponses, UpdateServiceAccountErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zUpdateServiceAccountResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/service-accounts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get API keys
 *
 * Lists the API keys of a service account. Secrets are never returned here.
 *
 * **GET /{tenantId}/{organizationId}/service-accounts/{id}/keys** ·· [getApiKeys](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/GET/{tenantId}/{organizationId}/service-accounts/{id}/keys) ·· _service-accounts · cella_
 *
 * @param {getApiKeysData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404
 */
export const getApiKeys = <ThrowOnError extends boolean = true>(
  options: Options<GetApiKeysData, ThrowOnError>,
): RequestResult<GetApiKeysResponses, GetApiKeysErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetApiKeysResponses, GetApiKeysErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetApiKeysResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/service-accounts/{id}/keys',
    ...options,
  });

/**
 * Create API key
 *
 * Issues an API key for a service account; the plaintext is returned once. With `rollFrom`, the previous key keeps working for the overlap window.
 *
 * **POST /{tenantId}/{organizationId}/service-accounts/{id}/keys** ·· [createApiKey](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/POST/{tenantId}/{organizationId}/service-accounts/{id}/keys) ·· _service-accounts · cella_
 *
 * @param {createApiKeyData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @param {string=} options.body.name - `string` (optional)
 * @param {any[] | null=} options.body.scopes - `any[] | null` (optional)
 * @param {string=} options.body.expiresAt - `string` (optional)
 * @param {string=} options.body.rollFrom - `string` (optional)
 * @param {integer=} options.body.rollOverlapDays - `integer` (optional)
 * @returns Possible status codes: 201, 400, 401, 403, 404, 413, 429
 */
export const createApiKey = <ThrowOnError extends boolean = true>(
  options: Options<CreateApiKeyData, ThrowOnError>,
): RequestResult<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zCreateApiKeyResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/service-accounts/{id}/keys',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Revoke API key
 *
 * Revokes an API key: it stops working within 10 seconds in every process. The row stays for the audit trail.
 *
 * **DELETE /{tenantId}/{organizationId}/service-accounts/{id}/keys/{keyId}** ·· [revokeApiKey](https://www.cellajs.com/docs/operations?operationTag=service-accounts#tag/service-accounts/DELETE/{tenantId}/{organizationId}/service-accounts/{id}/keys/{keyId}) ·· _service-accounts · cella_
 *
 * @param {revokeApiKeyData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {string} options.path.id - `string`
 * @param {string} options.path.keyId - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 429
 */
export const revokeApiKey = <ThrowOnError extends boolean = true>(
  options: Options<RevokeApiKeyData, ThrowOnError>,
): RequestResult<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).delete<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zRevokeApiKeyResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/service-accounts/{id}/keys/{keyId}',
    ...options,
  });

/**
 * Get Yjs token
 *
 * Returns an Ed25519-signed token for collaboratively editing one product entity the caller may update. It names the entity, its tenant and organization, and expires after five minutes; the Yjs relay worker verifies it with the public key alone, without a backend callback, and closes the socket when it expires.
 *
 * **GET /{tenantId}/{organizationId}/yjs/token** ·· [getYjsToken](https://www.cellajs.com/docs/operations?operationTag=yjs#tag/yjs/GET/{tenantId}/{organizationId}/yjs/token) ·· _yjs · cella_
 *
 * @param {getYjsTokenData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {enum} options.query.entityType - `enum`
 * @param {string} options.query.entityId - `string`
 * @returns Possible status codes: 200, 400, 401, 403, 404, 429
 */
export const getYjsToken = <ThrowOnError extends boolean = true>(
  options: Options<GetYjsTokenData, ThrowOnError>,
): RequestResult<GetYjsTokenResponses, GetYjsTokenErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).get<GetYjsTokenResponses, GetYjsTokenErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zGetYjsTokenResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/yjs/token',
    ...options,
  });

/**
 * Pull Yjs document
 *
 * Returns what the caller's copy of one product entity's collaborative document lacks, for a client that cannot reach the Yjs relay: the document's generation, an update holding what the caller's state vector lacks, and the server's state vector. A document never opened is seeded from the stored description first, as the relay seeds it. The caller must be allowed to update the entity, as for a Yjs token. A POST, since a state vector can outgrow a URL. Costs no API points.
 *
 * **POST /{tenantId}/{organizationId}/yjs/pull** ·· [pullYjsDocument](https://www.cellajs.com/docs/operations?operationTag=yjs#tag/yjs/POST/{tenantId}/{organizationId}/yjs/pull) ·· _yjs · cella_
 *
 * @param {pullYjsDocumentData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {enum=} options.body.entityType - `enum` (optional)
 * @param {string=} options.body.entityId - `string` (optional)
 * @param {string=} options.body.stateVector - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 413, 429
 */
export const pullYjsDocument = <ThrowOnError extends boolean = true>(
  options: Options<PullYjsDocumentData, ThrowOnError>,
): RequestResult<PullYjsDocumentResponses, PullYjsDocumentErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<PullYjsDocumentResponses, PullYjsDocumentErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPullYjsDocumentResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/yjs/pull',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Push Yjs update
 *
 * Appends one Yjs update to a product entity's collaborative document, for a client that cannot reach the Yjs relay. The answer follows the commit, so a 200 means the server holds the update; the relay passes it to live sessions and folds it into the document. An update made in another generation than the document's answers 409 `sync_document_replaced` with the current one in `meta.generation`, and with null when the document has no row: pull, which seeds it, then post again. At most 512 KB of update per request, base64url-encoded. The caller must be allowed to update the entity, as for a Yjs token. Costs no API points.
 *
 * **POST /{tenantId}/{organizationId}/yjs/push** ·· [pushYjsUpdate](https://www.cellajs.com/docs/operations?operationTag=yjs#tag/yjs/POST/{tenantId}/{organizationId}/yjs/push) ·· _yjs · cella_
 *
 * @param {pushYjsUpdateData} options
 * @param {string} options.path.tenantId - `string`
 * @param {string} options.path.organizationId - `string`
 * @param {enum=} options.body.entityType - `enum` (optional)
 * @param {string=} options.body.entityId - `string` (optional)
 * @param {string=} options.body.generation - `string` (optional)
 * @param {string=} options.body.update - `string` (optional)
 * @returns Possible status codes: 200, 400, 401, 403, 404, 409, 413, 429
 */
export const pushYjsUpdate = <ThrowOnError extends boolean = true>(
  options: Options<PushYjsUpdateData, ThrowOnError>,
): RequestResult<PushYjsUpdateResponses, PushYjsUpdateErrors, ThrowOnError, 'data'> =>
  (options.client ?? client).post<PushYjsUpdateResponses, PushYjsUpdateErrors, ThrowOnError, 'data'>({
    responseValidator: async (data) => await zPushYjsUpdateResponse.parseAsync(data),
    responseStyle: 'data',
    url: '/{tenantId}/{organizationId}/yjs/push',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
